<template>
  <v-main>
    <v-card :ripple="false" :img="ImgCover" height="240px" width="100%">
    </v-card>
    <v-card
      class="pa-6 pb-10 mt-n10"
      :color="DarkModeBackground"
      :style="
        'background-color:' +
          DarkModeBackground +
          ';min-height: 100vh;border-radius: 45px 45px 0px 0px;'
      "
    >
      <v-row>
        <v-col class="text-center">
          <v-avatar
            class="mt-n16 pa-1"
            style=""
            :color="DarkModeBackground"
            size="150"
          >
            <img :src="LoGo" />
          </v-avatar>
        </v-col>
      </v-row>
      <v-card class="pa-3 pt-6 pb-6 mt-16">
        <div
          v-if="
            (redirectBy === 'BookingForm' || redirectBy === 'BookingAdmin') &&
              DataFlow.length > 0
          "
          class="pa-0 ma-0"
        >
          <div v-if="paymentLoading" class="pa-0 ma-0">
            <!-- Loading ก่อนให้แสดง -->
            <div
              v-if="
                DataFlow[0].checkDeposit === 'True' &&
                  depositPrice > 0 &&
                  statusShowPayment === true
              "
            >
              <div v-if="bookingthankText !== null || bookingthankText !== ''">
                <!-- <textarea  disabled rows="5"  cols="50" style="resize: none;" v-model="bookingthankText"></textarea> -->
                <!-- <h5 v-html="nl2br(bookingthankText,false,false)" style="text-align: center;"></h5> -->
              </div>
              <!-- <div v-if="shop.length > 0" class="text-center">
            <h5 v-if="this.$route.query.shopId && (bookingthankText === null || bookingthankText === '' )" class="">ขอบคุณที่นัดหมายเข้าใช้บริการ</h5>
          </div> -->
              <h4 class="text-center font-weight-black">
                {{
                  languageSelect === 0
                    ? DataFlow[0].depositTextTH || "ชำระเงินมัดจำด้วย"
                    : DataFlow[0].depositTextEN || "Payment via"
                }}
              </h4>
              <!-- <h5 class="text-center font-weight-black" >{{languageSelect === 0 ? 'ชำระเงิน' : 'Payment'}}</h5> -->
              <p
                class="text-center mt-5"
                v-if="shopId === 'U753e6614793b89cffd5461cb76047d1c'"
              >
                {{
                  languageSelect === 0
                    ? "กรุณาชำระค่าเรียนได้ที่"
                    : "Please purchase your tuition fees at"
                }}
              </p>
              <p class="text-center mt-5" v-else>
                {{
                  languageSelect === 0
                    ? "กรุณาแคปหน้าจอ QR Code เพื่อดำเนินการจ่ายเงินด้วยแอพพลิเคชั่นของธนาคาร"
                    : "Please screenshot the QR code to pay with Bank application"
                }}
              </p>
              <div ref="capture">
                <v-card class="mt-6 mb-6 pb-6 " elevation="10">
                  <!-- <div ref="capture" ></div> -->
                  <v-img
                    v-if="showQrPayments === 'False'"
                    height="80%"
                    src="https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2FQR-prompt.jpg?alt=media&token=42637b63-af5b-45d9-8900-b866b789819e"
                  ></v-img>
                  <v-img
                    v-if="showQrPayments === 'True' && qrPaymentsImg === ''"
                    height="80%"
                    src="https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2FQR-prompt.jpg?alt=media&token=42637b63-af5b-45d9-8900-b866b789819e"
                  ></v-img>
                  <!-- <v-img
                height="80%"
                :src="require('@/assets/QR-prompt.jpg')"
              ></v-img> -->
                  <div
                    class="text-center"
                    v-if="value && showQrPayments === 'False'"
                  >
                    <qrcode-vue
                      :value="value"
                      :size="size"
                      level="H"
                      :foreground="foreground"
                    />
                  </div>
                  <div class="text-center" v-if="showQrPayments === 'True'">
                    <template v-if="qrPaymentsImg === ''">
                      <qrcode-vue
                        :value="value"
                        :size="size"
                        level="H"
                        :foreground="foreground"
                      />
                    </template>
                    <template v-if="qrPaymentsImg !== ''">
                      <v-img height="80%" :src="qrPaymentsImg"></v-img>
                    </template>
                  </div>
                  <h6
                    v-if="shop.length > 0 && shop[0].showShopName === 'True'"
                    class="text-center mt-3"
                  >
                    {{ shop[0].shopName }}
                  </h6>
                  <h6 class="text-center mt-0">
                    {{ languageSelect === 0 ? "บัญชี : " : "Account : "
                    }}{{ this.DataFlow[0].promptPayName }}
                  </h6>
                  <h6 class="text-center mt-0" v-if="depositPrice > 0">
                    {{
                      languageSelect === 0
                        ? "จำนวนเงิน : "
                        : "Deposit amount : "
                    }}{{ formatNumber(depositPrice)
                    }}{{ languageSelect === 0 ? " บาท" : " baht" }}
                  </h6>
                  <h6
                    class="text-center mt-10"
                    v-if="depositTime !== 'NO'"
                    style="color: red;"
                  >
                    (
                    {{
                      languageSelect === 0
                        ? "* ชำระเงินภายใน " +
                          (depositTimeItem.filter(i => i.value === depositTime).length > 0 ? depositTimeItem.filter(i => i.value === depositTime)[0].text : depositTime)
                        : "* Pay within  " +
                          (depositTimeItem.filter(i => i.value === depositTime).length > 0 ? depositTimeItem.filter(i => i.value === depositTime)[0].textEng : depositTime)
                    }}
                    )
                  </h6>
                  <h6 class="text-center mt-3">
                    (
                    {{
                      languageSelect === 0
                        ? "แนบสลิปการโอนเงินโดยกดที่ปุ่ม อัพโหลดสลิป"
                        : "Attach the transfer slip by clicking on the Upload Slip button."
                    }}
                    )
                  </h6>
                  <h6
                    class="text-left mt-3 pl-2"
                    style="color: red;font-size: 14px !important;"
                    v-if="checkSlipOK === true"
                  >
                    {{
                      languageSelect === 0
                        ? "*กรุณาโอนตามจำนวน ระบบจะไม่สามารถยืนยันการจองของคุณได้ หากจำนวนที่โอนไม่ถูกต้อง"
                        : "*Please transfer the correct amount. The system will not be able to confirm your reservation if the transferred amount is incorrect."
                    }}
                  </h6>
                  <div
                    v-if="shopId === 'U753e6614793b89cffd5461cb76047d1c'"
                    style="display: flex;justify-content: center;"
                    class="ma-1"
                  >
                    <v-btn dark small color="#2BC155" @click="coppyLink()">
                      คัดลอกหมายเลขบัญชี / PromptPay
                      <v-icon class="ml-1" dark>
                        mdi-content-copy
                      </v-icon>
                    </v-btn>
                  </div>
                </v-card>
              </div>
              <!-- <div class="text-center mt-5">
            <v-btn
            v-if="statuscheckCreditCard === 'True'"
            class="button pa-2"
            style="background-color: white; color: black; border: 1px solid black;"
            dark
            large
            @click="fnDownloadQR()"
            >{{ languageSelect === 0 ? "ดาวน์โหลด QR" : "Download QR" }}
          </v-btn>
          </div> -->
              <!-- <h6 class="text-center mt-5">กลังจากชำระแล้วกรุณาส่งหลักฐานสลิปโอนเงิน โดยคลิกปุ่มด้านล่าง</h6> -->
              <div class="text-center mt-5">
                <v-btn
                  v-if="statuscheckCreditCard === 'True'"
                  class="button pa-2"
                  style="background-color: #c0c0c0; color: black;"
                  large
                  @click="dialogCreditCard = true"
                  >{{ languageSelect === 0 ? "ย้อนกลับ" : "Back" }}
                </v-btn>
                <v-btn
                  class="button pa-2"
                  :color="DarkModeButton"
                  dark
                  large
                  @click="gotoPaymentUpload()"
                  >{{ languageSelect === 0 ? "อัพโหลดสลิป" : "Upload slip" }}
                </v-btn>
              </div>
              <div class="text-center">
                <v-btn
                  v-if="stripeBtstatus"
                  block
                  style="background-color: green; color: white;"
                  large
                  class="pa-2"
                  @click="goToPaymentLink()"
                  >{{
                    languageSelect === 0
                      ? "ชำระผ่านบัตรเครดิต (มีค่าธรรมเนียม))"
                      : "creditcard (Credit Usage Fee)"
                  }}
                </v-btn>
              </div>
            </div>
            <div v-else>
              <template v-if="languageSelect === 0">
                <div v-if="bookingthankText !== ''">
                  <!-- <textarea  disabled rows="5"  cols="50" style="resize: none;" v-model="bookingthankText"></textarea> -->
                  <!-- <h5 v-html="nl2br(bookingthankText,false,false)" style="text-align: center;"></h5> -->
                  <div v-if="languageSelect === 0">
                    <h5
                      v-html="nl2br(bookingthankText, false, false)"
                      style="text-align: center;"
                    ></h5>
                  </div>
                  <div v-else>
                    <h5
                      v-html="nl2br(bookingthankTextEn, false, false)"
                      style="text-align: center;"
                    ></h5>
                  </div>
                </div>
              </template>
              <template v-else>
                <div v-if="bookingthankTextEn !== ''">
                  <!-- <textarea  disabled rows="5"  cols="50" style="resize: none;" v-model="bookingthankText"></textarea> -->
                  <!-- <h5 v-html="nl2br(bookingthankTextEn,false,false)" style="text-align: center;"></h5> -->
                  <div v-if="languageSelect === 0">
                    <h5
                      v-html="nl2br(bookingthankText, false, false)"
                      style="text-align: center;"
                    ></h5>
                  </div>
                  <div v-else>
                    <h5
                      v-html="nl2br(bookingthankTextEn, false, false)"
                      style="text-align: center;"
                    ></h5>
                  </div>
                </div>
                <div
                  v-if="bookingthankTextEn === '' && bookingthankText !== ''"
                >
                  <!-- <textarea  disabled rows="5"  cols="50" style="resize: none;" v-model="bookingthankText"></textarea> -->
                  <!-- <h5 v-html="nl2br(bookingthankText,false,false)" style="text-align: center;"></h5> -->
                  <div v-if="languageSelect === 0">
                    <h5
                      v-html="nl2br(bookingthankText, false, false)"
                      style="text-align: center;"
                    ></h5>
                  </div>
                  <div v-else>
                    <h5
                      v-html="nl2br(bookingthankTextEn, false, false)"
                      style="text-align: center;"
                    ></h5>
                  </div>
                </div>
              </template>
              <div v-if="shop.length > 0" class="text-center">
                <div v-if="languageSelect === 0">
                  <h5
                    v-if="
                      $route.query.shopId &&
                        (bookingthankText === null || bookingthankText === '')
                    "
                    class=""
                  >
                    {{
                      "ทางทีมงาน " +
                        shop[0].shopName +
                        " จะติดต่อกลับให้เร็วที่สุด"
                    }}
                  </h5>
                </div>
                <div v-else>
                  <h5
                    v-if="
                      $route.query.shopId &&
                        (bookingthankTextEn === null ||
                          bookingthankTextEn === '')
                    "
                    class=""
                  >
                    {{
                      "Our team " +
                        shop[0].shopName +
                        " will contact you back soon."
                    }}
                  </h5>
                </div>
              </div>
              <!-- <h3 class="text-center" v-if="DarkModefont" :style="'color:' + DarkModefont +';'">ขอบคุณที่เข้ารับบริการกับเรา</h3> -->
              <div
                class="text-center"
                v-if="
                  showLineNotificationButton &&
                    dataLineConfig.checkConfig === false
                "
              >
                <v-btn
                  v-if="this.$route.query.shopId"
                  elevation="10"
                  color="green"
                  dark
                  :disabled="!valid"
                  @click="getBotinfo()"
                  >{{
                    languageSelect === 0
                      ? "รับการแจ้งเตือนผ่าน Line OA"
                      : "Get notified LINE OA"
                  }}</v-btn
                >
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="redirectBy === 'stampFirstStepErrorNoBook'"
          class="pa-0 ma-0"
        >
          <div class="text-center">
            <h5 v-html="nl2br(textByredirectBy, false, false)"></h5>
          </div>
          <div class="text-center mt-6">
            <v-btn
              v-if="this.$route.query.shopId"
              elevation="10"
              color="green"
              dark
              :disabled="!valid"
              @click="getBotinfo()"
              >{{
                languageSelect === 0
                  ? "ช่องทางติดต่อ Line OA"
                  : "Get notified LINE OA"
              }}</v-btn
            >
          </div>
        </div>
        <div
          v-else-if="redirectBy === 'stampFirstStepErrorNoDate'"
          class="pa-0 ma-0"
        >
          <div class="text-center">
            <h5 v-html="nl2br(textByredirectBy, false, false)"></h5>
          </div>
          <div class="text-center mt-6">
            <v-btn
              v-if="this.$route.query.shopId"
              elevation="10"
              color="green"
              dark
              :disabled="!valid"
              @click="getBotinfo()"
              >{{
                languageSelect === 0
                  ? "ช่องทางติดต่อ Line OA"
                  : "Get notified LINE OA"
              }}</v-btn
            >
          </div>
        </div>
        <div v-else-if="redirectBy === 'stampFirstStep'" class="pa-0 ma-0">
          <div class="text-center">
            <h5 v-html="nl2br(textByredirectBy, false, false)"></h5>
          </div>
          <div class="text-center mt-6">
            <v-btn
              v-if="this.$route.query.shopId"
              elevation="10"
              color="green"
              dark
              :disabled="!valid"
              @click="getBotinfo()"
              >{{
                languageSelect === 0
                  ? "ช่องทางติดต่อ Line OA"
                  : "Get notified LINE OA"
              }}</v-btn
            >
          </div>
        </div>
        <div v-else-if="redirectBy === 'rating'" class="pa-0 ma-0">
          <div class="text-center">
            <h5 v-html="nl2br(textByredirectBy, false, false)"></h5>
          </div>
          <div class="text-center mt-6">
            <v-btn
              v-if="this.$route.query.shopId"
              elevation="10"
              color="green"
              dark
              :disabled="!valid"
              @click="getBotinfo()"
              >{{
                languageSelect === 0
                  ? "ช่องทางติดต่อ Line OA"
                  : "Get notified LINE OA"
              }}</v-btn
            >
          </div>
        </div>
        <div v-else-if="redirectBy === 'ratingDuplicate'" class="pa-0 ma-0">
          <div class="text-center">
            <h5 v-html="nl2br(textByredirectBy, false, false)"></h5>
          </div>
          <div class="text-center mt-6">
            <v-btn
              v-if="this.$route.query.shopId"
              elevation="10"
              color="green"
              dark
              :disabled="!valid"
              @click="getBotinfo()"
              >{{
                languageSelect === 0
                  ? "ช่องทางติดต่อ Line OA"
                  : "Get notified LINE OA"
              }}</v-btn
            >
          </div>
        </div>
        <div v-else-if="redirectBy === 'ratingNoData'" class="pa-0 ma-0">
          <div class="text-center">
            <h5 v-html="nl2br(textByredirectBy, false, false)"></h5>
          </div>
          <div class="text-center mt-6">
            <v-btn
              v-if="this.$route.query.shopId"
              elevation="10"
              color="green"
              dark
              :disabled="!valid"
              @click="getBotinfo()"
              >{{
                languageSelect === 0
                  ? "ช่องทางติดต่อ Line OA"
                  : "Get notified LINE OA"
              }}</v-btn
            >
          </div>
        </div>
        <div v-else-if="redirectBy === 'ratingNoSave'" class="pa-0 ma-0">
          <div class="text-center">
            <h5 v-html="nl2br(textByredirectBy, false, false)"></h5>
          </div>
          <div class="text-center mt-6">
            <v-btn
              v-if="this.$route.query.shopId"
              elevation="10"
              color="green"
              dark
              :disabled="!valid"
              @click="getBotinfo()"
              >{{
                languageSelect === 0
                  ? "ช่องทางติดต่อ Line OA"
                  : "Get notified LINE OA"
              }}</v-btn
            >
          </div>
        </div>
        <div v-else-if="redirectBy === 'stampStepNoStep'" class="pa-0 ma-0">
          <div class="text-center">
            <h5 v-html="nl2br(textByredirectBy, false, false)"></h5>
          </div>
          <div class="text-center mt-6">
            <v-btn
              v-if="this.$route.query.shopId"
              elevation="10"
              color="green"
              dark
              :disabled="!valid"
              @click="getBotinfo()"
              >{{
                languageSelect === 0
                  ? "ช่องทางติดต่อ Line OA"
                  : "Get notified LINE OA"
              }}</v-btn
            >
          </div>
        </div>
        <div
          v-else-if="redirectBy === 'stampStepDuplicateStep'"
          class="pa-0 ma-0"
        >
          <div class="text-center">
            <h5 v-html="nl2br(textByredirectBy, false, false)"></h5>
          </div>
          <div class="text-center mt-6">
            <v-btn
              v-if="this.$route.query.shopId"
              elevation="10"
              color="green"
              dark
              :disabled="!valid"
              @click="getBotinfo()"
              >{{
                languageSelect === 0
                  ? "ช่องทางติดต่อ Line OA"
                  : "Get notified LINE OA"
              }}</v-btn
            >
          </div>
        </div>
        <div v-else-if="redirectBy === 'stampStepNoService'" class="pa-0 ma-0">
          <div class="text-center">
            <h5 v-html="nl2br(textByredirectBy, false, false)"></h5>
          </div>
          <div class="text-center mt-6">
            <v-btn
              v-if="this.$route.query.shopId"
              elevation="10"
              color="green"
              dark
              :disabled="!valid"
              @click="getBotinfo()"
              >{{
                languageSelect === 0
                  ? "ช่องทางติดต่อ Line OA"
                  : "Get notified LINE OA"
              }}</v-btn
            >
          </div>
        </div>
        <div v-else-if="redirectBy === 'stampStep'" class="pa-0 ma-0">
          <div class="text-center">
            <h5 v-html="nl2br(textByredirectBy, false, false)"></h5>
          </div>
          <div class="text-center mt-6">
            <v-btn
              v-if="this.$route.query.shopId"
              elevation="10"
              color="green"
              dark
              :disabled="!valid"
              @click="getBotinfo()"
              >{{
                languageSelect === 0
                  ? "ช่องทางติดต่อ Line OA"
                  : "Get notified LINE OA"
              }}</v-btn
            >
          </div>
        </div>
        <div v-else-if="redirectBy === 'notAcceptedPDPA'">
          <div class="text-center">
            <h5 v-html="nl2br(textByredirectBy, false, false)"></h5>
          </div>
          <div class="text-center mt-6">
            <v-btn
              v-if="this.$route.query.shopId"
              elevation="10"
              color="green"
              dark
              :disabled="!valid"
              @click="getBotinfo()"
              >{{
                languageSelect === 0
                  ? "ช่องทางติดต่อ Line OA"
                  : "Get notified LINE OA"
              }}</v-btn
            >
          </div>
        </div>
        <div
          v-else-if="
            redirectBy !== 'BookingForm' &&
              redirectBy !== 'BookingAdmin' &&
              redirectBy === 'N'
          "
          class="pa-0 ma-0"
        >
          <div class="text-center">
            <div v-if="languageSelect === 0">
              <h5
                v-if="bookingthankText === null || bookingthankText === ''"
                class=""
              >
                {{
                  languageSelect === 0
                    ? "ขอบคุณที่เข้ารับบริการกับเรา"
                    : "Thank you for your service."
                }}
              </h5>
              <h5
                v-else
                v-html="nl2br(bookingthankText, false, false)"
                style="text-align: center;"
              ></h5>
            </div>
            <div v-else>
              <h5
                v-if="bookingthankTextEn === null || bookingthankTextEn === ''"
                class=""
              >
                {{
                  languageSelect === 0
                    ? "ขอบคุณที่เข้ารับบริการกับเรา"
                    : "Thank you for your service."
                }}
              </h5>
              <h5
                v-else
                v-html="nl2br(bookingthankTextEn, false, false)"
                style="text-align: center;"
              ></h5>
            </div>
            <!-- <h5 v-if="bookingthankText === null || bookingthankText === ''" class="">{{ languageSelect === 0 ? "ขอบคุณที่เข้ารับบริการกับเรา" : "Thank you for your service." }}</h5>
          <h5 v-else v-html="nl2br(bookingthankText,false,false)" style="text-align: center;"></h5> -->
          </div>
          <div
            class="text-center"
            v-if="
              showLineNotificationButton &&
                dataLineConfig.checkConfig === false
            "
          >
            <v-btn
              v-if="this.$route.query.shopId"
              elevation="10"
              color="green"
              dark
              :disabled="!valid"
              @click="getBotinfo()"
              >{{
                languageSelect === 0
                  ? "รับการแจ้งเตือนผ่าน Line OA"
                  : "Get notified LINE OA"
              }}</v-btn
            >
          </div>
        </div>
        <div
          v-else-if="redirectBy === 'completedPayment' && paymentLink !== ''"
          class="pa-0 ma-0"
        >
          <template v-if="languageSelect === 0">
            <div v-if="bookingthankText !== ''">
              <!-- <textarea  disabled rows="5"  cols="50" style="resize: none;" v-model="bookingthankText"></textarea> -->
              <h5
                v-html="nl2br(bookingthankText, false, false)"
                style="text-align: center;"
              ></h5>
            </div>
          </template>
          <template v-else>
            <div v-if="bookingthankTextEn !== ''">
              <!-- <textarea  disabled rows="5"  cols="50" style="resize: none;" v-model="bookingthankText"></textarea> -->
              <h5
                v-html="nl2br(bookingthankTextEn, false, false)"
                style="text-align: center;"
              ></h5>
            </div>
            <div v-if="bookingthankTextEn === '' && bookingthankText !== ''">
              <!-- <textarea  disabled rows="5"  cols="50" style="resize: none;" v-model="bookingthankText"></textarea> -->
              <h5
                v-html="nl2br(bookingthankText, false, false)"
                style="text-align: center;"
              ></h5>
            </div>
          </template>
          <div v-if="shop.length > 0" class="text-center">
            <div v-if="languageSelect === 0">
              <h5
                v-if="
                  $route.query.shopId &&
                    (bookingthankText === null || bookingthankText === '')
                "
                class=""
              >
                {{
                  "ทางทีมงาน " + shop[0].shopName + " จะติดต่อกลับให้เร็วที่สุด"
                }}
              </h5>
            </div>
            <div v-else>
              <h5
                v-if="
                  $route.query.shopId &&
                    (bookingthankTextEn === null || bookingthankTextEn === '')
                "
                class=""
              >
                {{
                  "Our team " +
                    shop[0].shopName +
                    " will contact you back soon."
                }}
              </h5>
            </div>
          </div>
          <div
            class="text-center"
            v-if="
              showLineNotificationButton &&
                dataLineConfig.checkConfig === false
            "
          >
            <v-btn
              v-if="$route.query.shopId"
              elevation="10"
              color="green"
              dark
              :disabled="!valid"
              @click="getBotinfo()"
              >{{
                languageSelect === 0
                  ? "รับการแจ้งเตือนผ่าน Line OA"
                  : "Get notified LINE OA"
              }}</v-btn
            >
          </div>
        </div>
        <div
          v-else-if="
            redirectBy === 'PaymentUpload' || redirectBy === 'omisePayment'
          "
          class="pa-0 ma-0"
        >
          <template v-if="languageSelect === 0">
            <div v-if="bookingthankText !== ''">
              <!-- <textarea  disabled rows="5"  cols="50" style="resize: none;" v-model="bookingthankText"></textarea> -->
              <h5
                v-html="nl2br(bookingthankText, false, false)"
                style="text-align: center;"
              ></h5>
            </div>
          </template>
          <template v-else>
            <div v-if="bookingthankTextEn !== ''">
              <!-- <textarea  disabled rows="5"  cols="50" style="resize: none;" v-model="bookingthankText"></textarea> -->
              <h5
                v-html="nl2br(bookingthankTextEn, false, false)"
                style="text-align: center;"
              ></h5>
            </div>
            <div v-if="bookingthankTextEn === '' && bookingthankText !== ''">
              <!-- <textarea  disabled rows="5"  cols="50" style="resize: none;" v-model="bookingthankText"></textarea> -->
              <h5
                v-html="nl2br(bookingthankText, false, false)"
                style="text-align: center;"
              ></h5>
            </div>
          </template>
          <div v-if="shop.length > 0" class="text-center">
            <div v-if="languageSelect === 0">
              <h5
                v-if="
                  $route.query.shopId &&
                    (bookingthankText === null || bookingthankText === '')
                "
                class=""
              >
                {{
                  "ทางทีมงาน " + shop[0].shopName + " จะติดต่อกลับให้เร็วที่สุด"
                }}
              </h5>
            </div>
            <div v-else>
              <h5
                v-if="
                  $route.query.shopId &&
                    (bookingthankTextEn === null || bookingthankTextEn === '')
                "
                class=""
              >
                {{
                  "Our team " +
                    shop[0].shopName +
                    " will contact you back soon."
                }}
              </h5>
            </div>
          </div>
          <div
            class="text-center"
            v-if="
              showLineNotificationButton &&
                dataLineConfig.checkConfig === false
            "
          >
            <v-btn
              v-if="$route.query.shopId"
              elevation="10"
              color="green"
              dark
              :disabled="!valid"
              @click="getBotinfo()"
              >{{
                languageSelect === 0
                  ? "รับการแจ้งเตือนผ่าน Line OA"
                  : "Get notified LINE OA"
              }}</v-btn
            >
          </div>
        </div>
        <!-- <div v-else-if="redirectBy === 'createPayment' && paymentLink !== ''" class="pa-0 ma-0">
      <div  class="text-center">
          <h5 class="">{{ languageSelect === 0 ? "ขอบคุณที่เข้ารับบริการกับเรา" : "Thank you for your service." }}</h5>
        </div>
        <div class="text-center" v-if="paymentLink !== ''">
            <v-btn
            elevation="10"
            color="green"
            dark
            :disabled="!valid"
            @click="goToPaymentLink()"
          >{{ languageSelect === 0 ? "กดเพื่อชำระเงินอีกครั้ง" : "Press pay again" }}</v-btn>
        </div>
    </div> -->
      </v-card>
    </v-card>
    <v-dialog v-model="dialogCreditCard" fullscreen scrollable>
      <v-card>
        <!-- <v-container class="pa-0"> -->
        <v-overlay :value="overlay">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card-title class="pa-0 ma-0"> </v-card-title>
        <v-card-text>
          <v-card :ripple="false" :img="ImgCover" height="240px" width="100%">
          </v-card>
          <v-card
            class="pa-6 pb-10 mt-n10"
            :color="DarkModeBackground"
            :style="
              'background-color:' +
                DarkModeBackground +
                ';min-height: 100vh;border-radius: 45px 45px 0px 0px;'
            "
          >
            <v-row>
              <v-col class="text-center">
                <v-avatar
                  class="mt-n16 pa-1"
                  style=""
                  :color="DarkModeBackground"
                  size="150"
                >
                  <img :src="LoGo" />
                </v-avatar>
              </v-col>
            </v-row>
            <h4
              class="text-center mt-3 font-weight-black"
              :style="'color:' + DarkModefont + ';'"
            >
              {{ languageSelect === 0 ? "การชำระเงิน" : "Payment" }}
            </h4>
            <h5 class="text-center" :style="'color:' + DarkModefont + ';'">
              {{
                languageSelect === 0
                  ? "เลือกช่องทางการชำระเงิน"
                  : "Choose a payment method"
              }}
            </h5>
            <div
              class="pa-3 pt-6 pb-6 mt-5"
              :color="DarkModeBackground"
              style="display: flex;justify-content: center;align-items: center;flex-direction: column;"
            >
              <v-row>
                <v-col :cols="colswidth === 1 ? 12 : 6">
                  <v-sheet
                    :elevation="checkboxPromtpay === 'True' ? 5 : 1"
                    class="CDcontend"
                    color="#FFFFFF"
                    @click="selectPayment('checkboxPromtpay')"
                  >
                    <h5 class="mr-3">
                      {{
                        languageSelect === 0
                          ? "ชำระผ่าน QR PromtPay"
                          : "ชำระผ่าน QR PromtPay"
                      }}
                    </h5>
                    <v-icon
                      large
                      :color="
                        checkboxPromtpay === 'True' ? DarkModeButton : '#e0e0e0'
                      "
                    >
                      {{
                        checkboxPromtpay === "True"
                          ? "mdi-check-circle"
                          : "mdi-checkbox-blank-circle-outline"
                      }}
                    </v-icon>
                  </v-sheet>
                </v-col>
                <v-col
                  :cols="colswidth === 1 ? 12 : 6"
                  v-if="statuscheckCreditCard === 'True' && shopId !== 'U5febfe1716555403fb9073cff3b2fb84'"
                >
                  <v-sheet
                    :elevation="checkboxCreditCard === 'True' ? 5 : 1"
                    class="CDcontend"
                    @click="selectPayment('checkboxCreditCard')"
                    color="#FFFFFF"
                  >
                    <!-- {{ statuscheckRabbit }} -->
                    <h5 class="mr-3">
                      {{
                        languageSelect === 0
                          ? "ชำระผ่านบัตรเครดิต (มีค่าธรรมเนียม)"
                          : "creditcard (Credit Usage Fee)"
                      }}
                    </h5>
                    <v-icon
                      large
                      :color="
                        checkboxCreditCard === 'True'
                          ? DarkModeButton
                          : '#e0e0e0'
                      "
                    >
                      {{
                        checkboxCreditCard === "True"
                          ? "mdi-check-circle"
                          : "mdi-checkbox-blank-circle-outline"
                      }}
                    </v-icon>
                  </v-sheet>
                </v-col>
                <v-col
                  :cols="colswidth === 1 ? 12 : 6"
                  v-if="statuscheckRabbit === 'True'"
                >
                  <v-sheet
                    :elevation="checkboxRabbit === 'True' ? 5 : 1"
                    class="CDcontend"
                    @click="selectPayment('checkboxRabbit')"
                    color="#FFFFFF"
                  >
                    <h5 class="mr-3">
                      {{
                        languageSelect === 0
                          ? "ชำระผ่านบัตรเครดิต"
                          : "Pay with Credit Card"
                      }}
                    </h5>
                    <v-icon
                      large
                      :color="
                        checkboxRabbit === 'True'
                          ? DarkModeButton
                          : '#e0e0e0'
                      "
                    >
                      {{
                        checkboxRabbit === "True"
                          ? "mdi-check-circle"
                          : "mdi-checkbox-blank-circle-outline"
                      }}
                    </v-icon>
                  </v-sheet>
                </v-col>
                <v-col
                  :cols="colswidth === 1 ? 12 : 6"
                  v-if="statuscheckPagkageLoyalty === 'True'"
                >
                  <v-sheet
                    :elevation="statuscheckPagkageLoyalty === 'True' ? 5 : 1"
                    class="CDcontendLoyalty"
                    color="#FFFFFF"
                    @click="selectPayment('checkboxPackageLoyalty')"
                    v-if="
                      usePackageLoyalty.current_credits >= this.depositPrice
                    "
                  >
                    <div
                      class="py-3"
                      style="width: 100%;display: flex;flex-direction: column;justify-content: center;align-items: flex-start;"
                    >
                      <h5 class="ma-0 mb-1 font-weight-black">
                        {{ "ใช้เครดิต" }}
                      </h5>
                      <p class="ma-0">
                        {{
                          "คงเหลือ " +
                            usePackageLoyalty.current_credits.toLocaleString()
                        }}
                      </p>
                      <p class="ma-0">
                        {{
                          "จำนวนเครติดที่ต้องใช้ " +
                            this.depositPrice.toLocaleString()
                        }}
                      </p>
                    </div>
                    <!-- <h5 class="mr-3">
                      {{
                        languageSelect === 0
                          ? " หักจากแพคเกจ Loyalty"
                          : " use package loyalty"
                      }}
                    </h5> -->
                    <v-icon
                      large
                      :color="
                        checkboxPackageLoyalty === 'True'
                          ? DarkModeButton
                          : '#e0e0e0'
                      "
                    >
                      {{
                        checkboxPackageLoyalty === "True"
                          ? "mdi-check-circle"
                          : "mdi-checkbox-blank-circle-outline"
                      }}
                    </v-icon>
                  </v-sheet>
                  <v-sheet
                    :elevation="statuscheckPagkageLoyalty === 'True' ? 5 : 1"
                    class="CDcontendLoyalty"
                    color="#FFFFFF"
                    v-else
                  >
                    <div
                      class="py-3"
                      style="width: 100%;display: flex;flex-direction: column;justify-content: center;align-items: flex-start;"
                    >
                      <h5 class="ma-0 mb-1 font-weight-black">
                        {{ "ใช้เครดิต" }}
                      </h5>
                      <p class="ma-0" style="color: #6b6b6b;">
                        {{
                          "คงเหลือ " +
                            usePackageLoyalty.current_credits.toLocaleString()
                        }}
                      </p>
                      <p class="ma-0" style="color: #6b6b6b;">
                        {{
                          "จำนวนเครติดที่ต้องใช้ " +
                            this.depositPrice.toLocaleString()
                        }}
                      </p>
                      <p class="ma-0" style="color: #F44336;">
                        {{ "เครติดคงเหลือไม่เพียงพอ" }}
                      </p>
                    </div>
                    <!-- <h5 class="mr-3">
                      {{
                        languageSelect === 0
                          ? " หักจากแพคเกจ Loyalty"
                          : " use package loyalty"
                      }}
                    </h5> -->
                    <v-icon
                      large
                      :color="
                        checkboxPackageLoyalty === 'True'
                          ? DarkModeButton
                          : '#e0e0e0'
                      "
                    >
                      {{
                        checkboxPackageLoyalty === "True"
                          ? "mdi-check-circle"
                          : "mdi-checkbox-blank-circle-outline"
                      }}
                    </v-icon>
                  </v-sheet>
                </v-col>
                <v-col
                  :cols="colswidth === 1 ? 12 : 6"
                  v-if="statuscheckCoupon === 'True'"
                >
                  <v-sheet
                    :elevation="checkboxCreditCard === 'True' ? 5 : 1"
                    class="CDcontend"
                    @click="selectPayment('checkboxCoupon')"
                    color="#FFFFFF"
                  >
                    <h5 class="mr-3">
                      {{
                        languageSelect === 0
                          ? "ใช้คูปอง/อื่นๆ"
                          : "coupon and other"
                      }}
                    </h5>
                    <v-icon
                      large
                      :color="
                        checkboxCoupon === 'True' ? DarkModeButton : '#e0e0e0'
                      "
                    >
                      {{
                        checkboxCoupon === "True"
                          ? "mdi-check-circle"
                          : "mdi-checkbox-blank-circle-outline"
                      }}
                    </v-icon>
                  </v-sheet>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-card-text>

        <v-card-actions
          class="pa-0"
          :style="'display: flex;background:#FFFFFF;'"
        >
          <div
            class="pa-1 pt-2 px-10"
            style="width: 100%;background-color: #FFFFFF;border-radius: 40px 40px 0px 0px;"
          >
            <v-btn
              style="height: 55px;"
              class="button pa-2"
              :color="DarkModeButton"
              dark
              block
              large
              @click="gotocheckCreditCard()"
              >{{ languageSelect === 0 ? "ยืนยัน" : "Confirm" }}
              <v-icon class="ml-3" dark>mdi-arrow-right</v-icon>
            </v-btn>
          </div>
        </v-card-actions>
        <!-- </v-container> -->
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogSelectOnlinePayment" fullscreen scrollable>
      <v-card>
        <v-card-title class="pa-0 ma-0"> </v-card-title>
        <v-card-text>
          <v-card :ripple="false" :img="ImgCover" height="240px" width="100%">
          </v-card>
          <v-card
            class="pa-6 pb-10 mt-n10"
            :color="DarkModeBackground"
            :style="
              'background-color:' +
                DarkModeBackground +
                ';min-height: 100vh;border-radius: 45px 45px 0px 0px;'
            "
          >
            <v-row>
              <v-col class="text-center">
                <v-avatar
                  class="mt-n16 pa-1"
                  style=""
                  :color="DarkModeBackground"
                  size="150"
                >
                  <img :src="LoGo" />
                </v-avatar>
              </v-col>
            </v-row>
            <h4
              class="text-center mt-3 font-weight-black"
              :style="'color:' + DarkModefont + ';'"
            >
              {{ languageSelect === 0 ? "การชำระเงิน" : "Payment" }}
            </h4>
            <h5 class="text-center" :style="'color:' + DarkModefont + ';'">
              {{
                languageSelect === 0
                  ? "เลือกช่องทางการชำระเงิน"
                  : "Choose a payment method"
              }}
            </h5>
            <div
              class="pa-3 pt-6 pb-6 mt-5"
              :color="DarkModeBackground"
              style="display: flex;justify-content: center;align-items: center;flex-direction: column;"
            >
              <v-row>
                <v-col :cols="colswidth === 1 ? 12 : 6">
                  <v-sheet
                    :elevation="checkboxPromtpayOnline === true ? 5 : 1"
                    class="CDcontend"
                    color="#FFFFFF"
                    @click="selectPayment('stripe')"
                  >
                    <h5 class="mr-3">
                      {{ languageSelect === 0 ? "Stripe" : "Stripe" }}
                    </h5>
                    <v-icon
                      large
                      :color="
                        checkboxPromtpayOnline === true
                          ? DarkModeButton
                          : '#e0e0e0'
                      "
                    >
                      {{
                        checkboxPromtpayOnline === true
                          ? "mdi-check-circle"
                          : "mdi-checkbox-blank-circle-outline"
                      }}
                    </v-icon>
                  </v-sheet>
                </v-col>
                <v-col :cols="colswidth === 1 ? 12 : 6">
                  <v-sheet
                    :elevation="checkboxPromtpayOnline === false ? 5 : 1"
                    class="CDcontend"
                    @click="selectPayment('omise')"
                    color="#FFFFFF"
                  >
                    <h5 class="mr-3">
                      {{ languageSelect === 0 ? "Omise" : "Omise" }}
                    </h5>
                    <v-icon
                      large
                      :color="
                        checkboxPromtpayOnline === false
                          ? DarkModeButton
                          : '#e0e0e0'
                      "
                    >
                      {{
                        checkboxPromtpayOnline === false
                          ? "mdi-check-circle"
                          : "mdi-checkbox-blank-circle-outline"
                      }}
                    </v-icon>
                  </v-sheet>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-card-text>

        <v-card-actions
          class="pa-0"
          :style="'display: flex;background:#FFFFFF;'"
        >
          <div
            class="pa-3 pt-5 px-10"
            style="width: 100%;background-color: #FFFFFF;border-radius: 40px 40px 0px 0px;"
          >
            <v-btn
              style="height: 55px;"
              class="button pa-2"
              :color="DarkModeButton"
              dark
              block
              large
              @click="gotocheckCreditCardOnline()"
              >{{ languageSelect === 0 ? "ยืนยัน" : "Confirm" }}
              <v-icon class="ml-3" dark>mdi-arrow-right</v-icon>
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <GoogleCalendar ref="GoogleCalendarRef" />
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-main>
</template>

<script>
import axios from 'axios' // api
import QrcodeVue from 'qrcode.vue'
import moment from 'moment-timezone'
import GoogleCalendar from '../Core/GoogleCalendarCmp.vue'
// import html2canvas from 'html2canvas'
export default {
  components: {
    name: '',
    QrcodeVue,
    GoogleCalendar
  },
  computed: {
    showLineNotificationButton () {
      return String(this.$route.query.shopId || '') !== String(this.shopNameData.pribta21)
    },
    colswidth () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 1
        case 'sm':
          return 1
        case 'md':
          return 1
        case 'lg':
          return 2
        case 'xl':
          return 2
      }
    }
  },
  data () {
    return {
      overlay: false,
      qrCodeImageSrc: null,
      statusShowPayment: true,
      value: null,
      size: 200,
      foreground: '#000000',
      valid: true,
      GroupId: this.$route.query.GroupId,
      flowId: this.$route.query.flowId,
      bookNo: this.$route.query.bookNo,
      dataOmisePayment: null,
      languageSelect: 0,
      userName: '',
      userPassword: '',
      shopId: this.$route.query.shopId,
      profile: null,
      fromAdd: {
        GroupId: '',
        shopId: '',
        bookingStatus: 'N'
      },
      rules: {
        numberRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: value => value.length <= 10 || 'Max 10 characters',
        IDcardRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: value => !!value || 'กรุณากรอก.',
        resizeImag: value =>
          !value ||
          value.size < 2000000 ||
          'Avatar size should be less than 2 MB!',
        counterIDcard: value => value.length <= 13 || 'Max 13 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      dialog: false,
      ColorByShop: [],
      DarkMode: '',
      DarkModeStatus: null,
      DarkModeButton: '',
      DarkModeBackground: '',
      DarkModefont: '',
      shop: [],
      LoGo: [],
      ImgCover: '',
      bookingthankText: null,
      bookingthankTextEn: null,
      redirectBy: null,
      DataFlow: [],
      depositPrice: 0,
      textByredirectBy: '',
      checkMemberId: '',
      showQrPayments: 'False',
      qrPaymentsImg: '',
      dataLineConfig: {},
      statusEngPayment: 'False',
      bookingItem: [],
      statuscheckCreditCard: 'False',
      statuscheckRabbit: 'False',
      statuscheckCoupon: 'False',
      statuscheckPagkageLoyalty: 'False',
      dialogCreditCard: false,
      stripeBtstatus: false,
      checkboxPromtpay: 'True',
      checkboxCreditCard: 'False',
      checkboxRabbit: 'False',
      checkboxCoupon: 'False',
      checkboxPackageLoyalty: 'False',
      depositTime: '',
      paymentLink: '',
      depositTimeItem: [
        {
          text: 'ไม่จำกัดเวลามัดจำ',
          textEng: 'ไม่จำกัดเวลามัดจำ',
          value: 'NO'
        },
        { text: '10 นาที', textEng: '10 Min', value: '10' },
        { text: '15 นาที', textEng: '15 Min', value: '15' },
        { text: 'ครึ่งชั่วโมง', textEng: '30 Min', value: '30' },
        { text: '1 ชั่วโมง', textEng: '1 Hour', value: '60' },
        { text: '3 ชั่วโมง', textEng: '3 Hour', value: '180' },
        { text: '6 ชั่วโมง', textEng: '6 Hour', value: '360' },
        { text: '1 วัน', textEng: '1 Day', value: '1440' }
      ],
      paymentSelect: null,
      endpointSecret: null,
      apiKey: null,
      dataPaymentGet: [],
      dataPaymentCoppy: [],
      dialogSelectOnlinePayment: false,
      checkboxPromtpayOnline: true,
      checkSlipOK: false,
      promptPayID: null,
      amount: 0,
      usePackageLoyalty: {
        memberId: null,
        Amount_credited: 0,
        admin_note: '',
        customer_note: '',
        current_credits: 0,
        total_credits: 0,
        time: '',
        date: '',
        pointAfterDecrease: 0,
        statusUse: false
      },
      statusGoogleCalendar: null,
      statusGoogleCalendarEmp: null,
      paymentLoading: false,
      dataRabbit: {}
    }
  },
  async mounted () {
    try {
      let checkShopId = ''
      if (this.$route.query.shopId) {
        checkShopId = this.$route.query.shopId
      } else {
        const queryString = decodeURIComponent(window.location.search).replace(
          '?liff.state=',
          ''
        )
        const params = new URLSearchParams(queryString)
        checkShopId = params.get('shopId')
      }
      this.dataLineConfig = await this.getDataLineConfig(checkShopId)
      await this.getShop()
      await this.setText()
      await this.getBookingField()
      await this.getBooking()
      await this.checkPayment()
      await this.getDataFlow()
      this.paymentLoading = false
      // เช็คยอกเงิน + save ยอดเงิน
      await this.summaryOfMoney()
      // เช็ค เครดิตการ์ด
      const creditCardResult = await this.creditCardFnc()

      // หากใช้คูปองจบสิ้นแล้ว ให้หยุดการเรนเดอร์ UI จ่ายเงินส่วนอื่นๆ เลย (ป้องกัน genQrCode หลงรันซ้อน)
      if (creditCardResult === 'coupon_used') {
        this.paymentLoading = false
        return
      }

      // สรุปยอดเงิน genQrCode
      await this.genQrCode()
      await this.checkRabbit()
      this.paymentLoading = true
      if (this.$route.query.languageSelect) {
        this.languageSelect = parseInt(this.$route.query.languageSelect)
        if (this.languageSelect === 0) {
          this.statusShowPayment = true
        } else {
          if (this.statusEngPayment === 'True') {
            this.statusShowPayment = true
          } else {
            this.statusShowPayment = false
          }
        }
      } else {
        this.statusShowPayment = true
        this.languageSelect = 0
      }
      await axios
        .get(
          this.DNS_IP +
            '/master_payment/get?shopId=' +
            this.$route.query.shopId +
            '&switchSlipOK=true&payType=SlipOK'
        )
        .then(res => {
          this.checkSlipOK = res.data.status
        })
        .catch(error => {
          console.log('error master_payment get: ', error)
        })
    } catch (error) {
      console.log('error mounted Thank: ', error)
    }
  },
  created () {
    window.addEventListener('resize', this.myEventHandler)
  },
  destroyed () {
    window.removeEventListener('resize', this.myEventHandler)
  },
  methods: {
    async checkRabbit () {
      try {
        const resDataFlow = await this.DataFlow
        if (resDataFlow && resDataFlow.length > 0) {
          if (resDataFlow[0].checkCreditCard === 'True') {
            await axios.get(
              this.DNS_IP +
            '/master_payment/get?shopId=' +
            this.$route.query.shopId +
            '&switchRabbit=true&payType=rabbit'
            )
              .then(res => {
                if (res.data.status !== false) {
                  this.statuscheckRabbit = 'True'
                  this.dataRabbit = res.data[0]
                } else {
                  this.statuscheckRabbit = 'False'
                }
              })
              .catch(error => {
                console.log('checkRabbit axios error:', error)
                this.statuscheckRabbit = 'False'
              })
          } else {
            this.statuscheckRabbit = 'False'
          }
        } else {
          this.statuscheckRabbit = 'False'
        }
      } catch (error) {
        console.log('checkRabbit error:', error)
        this.statuscheckRabbit = 'False'
      }
    },

    // async fnDownloadQR () {
    //   try {
    //     // Wait for Vue to update the DOM
    //     await this.$nextTick()

    //     // Capture the element
    //     const element = this.$refs.capture
    //     const canvas = await html2canvas(element, {
    //       useCORS: true // Enable CORS if using images from other domains
    //     })

    //     const dataUrl = canvas.toDataURL('image/png')
    //     const link = document.createElement('a')
    //     link.href = dataUrl
    //     link.download = 'QRcode.png'

    //     document.body.appendChild(link)
    //     link.click()
    //     document.body.removeChild(link)
    //     console.log('this.qrCodeImageSrc>>>>', this.qrCodeImageSrc)
    //   } catch (error) {
    //     console.error('Error capturing image:', error)
    //   }
    // },
    async getCheckOmise () {
      try {
        await axios
          .get(
            this.DNS_IP +
              '/master_payment/get?shopId=' +
              this.$route.query.shopId +
              '&payType=omise'
          )
          .then(response => {
            let rs = response.data
            if (rs.status !== false && rs.length > 0) {
              this.apiKey = rs[0].apiKey
              this.endpointSecret = rs[0].endpointSecret
              if (Array.isArray(rs)) {
                if (rs[0].masBranchID === 'All') {
                  this.dataOmisePayment = rs[0]
                  this.paymentSelect = JSON.parse(
                    this.dataOmisePayment.payMentSelect
                  )
                  if (this.paymentSelect.find(item => item === 'credit_card')) {
                    let creditCard = this.paymentSelect.filter(
                      item => item === 'credit_card'
                    )
                    this.paymentSelect = this.paymentSelect.filter(
                      item => item !== 'credit_card'
                    )
                    this.paymentSelect.unshift(creditCard[0])
                  }
                } else {
                  if (this.bookingItem && this.bookingItem.length > 0) {
                    this.dataOmisePayment = rs.filter(
                      item =>
                        item.masBranchID ===
                        this.bookingItem[0].masBranchID.toString()
                    )
                    if (this.dataOmisePayment && this.dataOmisePayment.length > 0) {
                      this.paymentSelect = JSON.parse(
                        this.dataOmisePayment[0].payMentSelect
                      )
                      if (this.paymentSelect.find(item => item === 'credit_card')) {
                        let creditCard = this.paymentSelect.filter(
                          item => item === 'credit_card'
                        )
                        this.paymentSelect = this.paymentSelect.filter(
                          item => item !== 'credit_card'
                        )
                        this.paymentSelect.unshift(creditCard[0])
                      }
                    }
                  }
                }
              }
            }
          })
          .catch(function (error) {
            console.log('Error getCheckOmise axios: ' + error)
          })
      } catch (error) {
        console.error('getCheckOmise critical error:', error)
      }
    },
    async coppyLink () {
      try {
        let dataCoppy = ''
        let text = 'PromptPay'
        if (this.showQrPayments === 'True') {
          if (this.dataPaymentCoppy && this.dataPaymentCoppy.length > 0) {
            dataCoppy = this.dataPaymentCoppy[0].payAccountNo
            text = 'บัญชี'
          }
        } else {
          if (this.DataFlow && this.DataFlow.length > 0) {
            dataCoppy = this.DataFlow[0].promptPayID
          }
        }

        if (dataCoppy && dataCoppy.trim() !== '') {
          this.$swal({
            title: 'Copy successfully',
            text: `กรุณาตรวจสอบก่อนทำการชำระเงิน หมายเลข ${text}`,
            type: 'success',
            timer: 2000,
            showConfirmButton: false
          })
          if (navigator.clipboard) {
            await navigator.clipboard.writeText(dataCoppy)
          }
        } else {
          this.$swal({
            title: 'Coppy False',
            text: `ไม่พบหมายเลข ${text}`,
            type: 'info',
            timer: 2000,
            showConfirmButton: false
          })
        }
      } catch (error) {
        console.error('coppyLink error:', error)
      }
    },
    async checkPayment () {
      try {
        if (this.showQrPayments === 'True') {
          await axios
            .get(
              this.DNS_IP +
                '/master_payment/get?shopId=' +
                this.$route.query.shopId
            )
            .then(response => {
              let rs = response.data
              if (rs.status !== false) {
                this.dataPaymentGet = rs
                if (this.bookingItem && this.bookingItem.length > 0) {
                  let checkBranch = rs.filter(el => {
                    return (
                      parseInt(el.masBranchID) ===
                        this.bookingItem[0].masBranchID &&
                      el.payType === 'payment'
                    )
                  })
                  this.dataPaymentCoppy = rs.filter(el => {
                    return (
                      parseInt(el.masBranchID) ===
                        this.bookingItem[0].masBranchID &&
                      el.payType === 'payment'
                    )
                  })
                  if (checkBranch.length > 0) {
                    this.qrPaymentsImg = checkBranch[0].payTypeImage || ''
                  } else {
                    let checkBranchAll = rs.filter(el => {
                      return el.masBranchID === 'All' && el.payType === 'payment'
                    })
                    if (checkBranchAll.length > 0) {
                      this.qrPaymentsImg = checkBranchAll[0].payTypeImage || ''
                    } else {
                      this.qrPaymentsImg = ''
                    }
                  }
                } else {
                  let checkBranchAll = rs.filter(el => {
                    return el.masBranchID === 'All' && el.payType === 'payment'
                  })
                  if (checkBranchAll.length > 0) {
                    this.qrPaymentsImg = checkBranchAll[0].payTypeImage || ''
                  } else {
                    this.qrPaymentsImg = ''
                  }
                }
              } else {
                this.qrPaymentsImg = ''
                this.dataPaymentGet = []
              }
            })
            .catch(error => {
              console.log('checkPayment axios error (showQrPayments):', error)
              this.qrPaymentsImg = ''
              this.dataPaymentGet = []
            })
        } else {
          await axios
            .get(
              this.DNS_IP +
                '/master_payment/get?shopId=' +
                this.$route.query.shopId
            )
            .then(response => {
              let rs = response.data
              if (rs.status !== false) {
                this.dataPaymentGet = rs
              } else {
                this.dataPaymentGet = []
              }
            })
            .catch(error => {
              console.log('checkPayment axios error:', error)
              this.dataPaymentGet = []
            })
        }
      } catch (error) {
        console.error('checkPayment critical error:', error)
      }
    },
    selectPayment (item) {
      if (item === 'checkboxCreditCard') {
        this.checkboxCreditCard = 'True'
        this.checkboxRabbit = 'False'
        this.checkboxPromtpay = 'False'
        this.checkboxCoupon = 'False'
        this.checkboxPackageLoyalty = 'False'
      } else if (item === 'checkboxRabbit') {
        this.checkboxRabbit = 'True'
        this.checkboxCreditCard = 'False'
        this.checkboxCoupon = 'False'
        this.checkboxPromtpay = 'False'
        this.checkboxCreditCard = 'False'
        this.checkboxPackageLoyalty = 'False'
      } else if (item === 'checkboxCoupon') {
        this.checkboxCoupon = 'True'
        this.checkboxRabbit = 'False'
        this.checkboxPromtpay = 'False'
        this.checkboxCreditCard = 'False'
        this.checkboxPackageLoyalty = 'False'
      } else if (item === 'checkboxPackageLoyalty') {
        this.checkboxCoupon = 'False'
        this.checkboxPromtpay = 'False'
        this.checkboxCreditCard = 'False'
        this.checkboxPackageLoyalty = 'True'
        this.checkboxRabbit = 'False'
      } else {
        if (item === 'stripe') {
          this.checkboxPromtpayOnline = true
        } else if (item === 'omise') {
          this.checkboxPromtpayOnline = false
        } else {
          this.checkboxCreditCard = 'False'
          this.checkboxCoupon = 'False'
          this.checkboxPromtpay = 'True'
          this.checkboxPackageLoyalty = 'False'
          this.checkboxRabbit = 'False'
        }
      }
    },
    async getBookingField () {
      this.statusEngPayment = 'False'
      await axios
        .get(
          this.DNS_IP + '/BookingField/get?shopId=' + this.$route.query.shopId
        )
        .then(async response => {
          let rs = response.data
          if (rs.length > 0) {
            this.statusEngPayment = rs[0].statusEngPayment || 'False'
          } else {
            this.statusEngPayment = 'False'
          }
        })
        .catch(error => {
          console.log('error getBookingField: ', error)
        })
    },
    nl2br (str, replaceMode, isXhtml) {
      let text = str || ''
      var breakTag = isXhtml ? '<br />' : '<br>'
      var replaceStr = replaceMode ? '$1' + breakTag : '$1' + breakTag + '$2'
      return (text + '').replace(
        /(&nbsp|[^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
        replaceStr
      )
    },
    myEventHandler (e) {
      this.getSceenSize()
    },
    getSceenSize () {
      this.widthScreen = window.innerWidth
      if (this.widthScreen < 300) {
        this.size = 100
      } else if (this.widthScreen > 300 && this.widthScreen < 500) {
        this.size = 200
      } else if (this.widthScreen > 500) {
        this.size = 400
      }
    },
    async genQrCode () {
      if (this.bookingItem && this.bookingItem.length > 0) {
        try {
          const generatePayload = await require('promptpay-qr')
          let amount = this.amount
          let promptPayID = this.promptPayID
          await axios
            .get(
              this.DNS_IP +
                '/master_payment/get?shopId=' +
                this.$route.query.shopId +
                '&branchIn=' +
                this.bookingItem[0].masBranchID +
                '&payType=stripe'
            )
            .then(async response => {
              if (response.data.status !== false) {
                let paymentLinkCheck = this.bookingItem[0].paymentLink || ''
                let paymentLinkStatusCheck =
                  this.bookingItem[0].paymentLinkStatus || ''
                let paymentType = this.bookingItem[0].paymentType || ''
                if (
                  paymentLinkCheck === '' &&
                  paymentType === 'stripe' &&
                  this.statuscheckCreditCard === 'True'
                ) {
                  let dataBooking = {
                    depositStatus: 'False',
                    depositPrice: amount
                  }
                  await axios
                    .post(
                      this.DNS_IP + '/Booking/edit/' + this.bookingItem[0].bookNo,
                      dataBooking
                    )
                    .then(async responsess => {
                      this.stripeBtstatus = true
                      this.value = generatePayload(promptPayID, { amount })
                    })
                } else if (
                  paymentType === 'stripe' &&
                  paymentLinkStatusCheck !== '' &&
                  this.statuscheckCreditCard === 'True'
                ) {
                  if (paymentLinkStatusCheck === 'create') {
                    // this.redirectBy = 'createPayment'
                    this.stripeBtstatus = true
                    window.location.href = paymentLinkCheck
                    // this.paymentLink = paymentLinkCheck
                    // this.value = generatePayload(promptPayID, { amount })
                  } else if (paymentLinkStatusCheck === 'completed') {
                    this.redirectBy = 'completedPayment'
                  }
                } else if (
                  paymentType === '' &&
                  this.statuscheckCreditCard === 'True'
                ) {
                  let dataBooking = {
                    depositStatus: 'False',
                    depositPrice: amount
                  }
                  await axios
                    .post(
                      this.DNS_IP + '/Booking/edit/' + this.bookingItem[0].bookNo,
                      dataBooking
                    )
                    .then(async responsess => {
                      this.stripeBtstatus = true
                      this.value = generatePayload(promptPayID, { amount })
                    })
                }
              } else {
                if (promptPayID !== null) {
                  this.value = generatePayload(promptPayID, { amount }) // First parameter : mobileNumber || IDCardNumber
                }
              }
            })
            .catch((error) => {
              console.error('Error genQrCode axios:', error)
              if (this.DataFlow && this.DataFlow.length > 0) {
                const promptPayID = this.DataFlow[0].promptPayID
                let amount = 0
                // const IDCardNumber = '0-0000-00000-00-0'
                if (this.redirectBy === 'BookingAdmin') {
                  amount = this.depositPrice
                } else {
                  if (this.DataFlow[0].menuShowStatus === 'True') {
                    if (this.DataFlow[0].depositPercent > 0) {
                      const percentage = this.DataFlow[0].depositPercent
                      const amount =
                        (percentage / 100) *
                        parseFloat(this.bookingItem[0].menuPrice)
                      this.depositPrice =
                        parseFloat(amount) +
                        parseFloat(this.DataFlow[0].amountDeposit || 0)
                    } else {
                      this.depositPrice =
                        parseFloat(this.bookingItem[0].menuPrice) +
                        parseFloat(this.DataFlow[0].amountDeposit || 0)
                    }
                  } else {
                    amount = this.DataFlow[0].amountDeposit
                    if (this.$route.query.Calculate) {
                      this.depositPrice =
                        parseFloat(this.DataFlow[0].amountDeposit) *
                        parseFloat(this.$route.query.Calculate)
                    } else {
                      this.depositPrice = parseFloat(this.DataFlow[0].amountDeposit)
                    }
                  }
                  this.depositPrice = parseFloat(parseFloat(this.depositPrice).toFixed(2))
                  amount = this.depositPrice
                }
                this.value = generatePayload(promptPayID, { amount }) // First parameter : mobileNumber || IDCardNumber
              }
            })
        } catch (error) {
          console.error('genQrCode critical error:', error)
        }
      }
    },
    async summaryOfMoney () {
      if (!this.bookingItem || this.bookingItem.length === 0) {
        console.warn('summaryOfMoney: bookingItem is empty or undefined')
        return
      }
      try {
        if (this.DataFlow && this.DataFlow.length > 0) {
          this.getCheckOmise()
          if (
            this.DataFlow[0].promptPayID !== null &&
            this.DataFlow[0].amountDeposit !== null
          ) {
            // const generatePayload = await require('promptpay-qr')
            this.promptPayID = this.DataFlow[0].promptPayID
            this.amount = 0
            // const IDCardNumber = '0-0000-00000-00-0'
            if (this.redirectBy === 'BookingAdmin') {
              this.amount = this.depositPrice
              this.saveDepositPrice(this.amount)
            } else {
              if (this.DataFlow[0].menuShowStatus === 'True') {
                if (this.DataFlow[0].depositPercent > 0) {
                  const percentage = this.DataFlow[0].depositPercent
                  this.amount =
                    (percentage / 100) *
                    parseFloat(this.bookingItem[0].menuPrice)
                  this.depositPrice =
                    parseFloat(this.amount) +
                    parseFloat(this.DataFlow[0].amountDeposit || 0)
                } else {
                  let menuPrice = ''
                  if (
                    this.bookingItem[0].menuPrice === '' ||
                    this.bookingItem[0].menuPrice === 0
                  ) {
                    menuPrice = 0
                  } else {
                    menuPrice = parseFloat(this.bookingItem[0].menuPrice)
                  }
                  this.depositPrice =
                    menuPrice + parseFloat(this.DataFlow[0].amountDeposit || 0)
                }
              } else {
                this.amount = this.DataFlow[0].amountDeposit
                if (this.DataFlow[0].depositPercent > 0) {
                  const percentage = this.DataFlow[0].depositPercent
                  if (this.$route.query.Calculate) {
                    this.depositPrice =
                      (percentage / 100) *
                      (parseFloat(this.DataFlow[0].amountDeposit) *
                        parseFloat(this.$route.query.Calculate))
                  } else {
                    this.depositPrice =
                      (percentage / 100) *
                      parseFloat(this.DataFlow[0].amountDeposit)
                  }
                } else {
                  if (this.$route.query.Calculate) {
                    this.depositPrice =
                      parseFloat(this.DataFlow[0].amountDeposit) *
                      parseFloat(this.$route.query.Calculate)
                  } else {
                    this.depositPrice = parseFloat(
                      this.DataFlow[0].amountDeposit
                    )
                  }
                }
              }
              this.depositPrice = parseFloat(parseFloat(this.depositPrice).toFixed(2))
              this.amount = this.depositPrice
              this.saveDepositPrice(this.amount)
            }
          }
        }
      } catch (error) {
        console.error('summaryOfMoney error:', error)
      }
    },
    async saveDepositPrice (amount) {
      if (!this.bookingItem || this.bookingItem.length === 0) {
        console.warn('saveDepositPrice: bookingItem is empty or undefined')
        return
      }
      try {
        if (this.bookingItem[0].depositStatus !== 'True') {
          let dataBooking = {
            depositStatus: 'False',
            depositPrice: amount
          }
          await axios
            .post(
              this.DNS_IP + '/Booking/edit/' + this.bookingItem[0].bookNo,
              dataBooking
            )
            .then(async respons => {
              console.log('saveDepositPrice', respons)
            })
            .catch(error => {
              console.log('saveDepositPrice axios error: ', error)
            })
        }
      } catch (error) {
        console.error('saveDepositPrice error:', error)
      }
    },
    async goToPaymentLinkOmise () {
      try {
        let omisePayment = (this.dataPaymentGet || []).filter(
          ii => ii.payType === 'omise'
        )
        if (omisePayment && omisePayment.length > 0) {
          let payVatExcludeOmise = omisePayment[0].payVatExclude
          if (this.dataOmisePayment) {
            this.$OmiseCard.configure({
              publicKey: this.apiKey
            })
            this.$OmiseCard.open({
              publicKey: this.apiKey,
              frameLabel: (this.shop && this.shop.length > 0) ? this.shop[0].shopName : 'Payment',
              amount:
                payVatExcludeOmise > 0
                  ? ((payVatExcludeOmise / 100) * this.depositPrice +
                      this.depositPrice) *
                    100
                  : this.depositPrice * 100,
              currency: 'thb',
              otherPaymentMethods: this.paymentSelect,
              onCreateTokenSuccess: nonce => {
                console.log(nonce)
                this.handleOmisepayment(nonce)
              }
            })
          } else {
            await this.pushMsgLineNotifyGroup(this.bookNo)
            this.dialogCreditCard = false
            this.statuscheckCreditCard = 'False'
            this.$router.push(
              '/Thank?shopId=' +
                this.shopId +
                '&redirectBy=checkCreditCard&flowId=' +
                this.$route.query.flowId +
                '&bookNo=' +
                this.bookNo
            )
            window.location.reload()
          }
        }
      } catch (error) {
        console.error('goToPaymentLinkOmise error:', error)
      }
    },
    async goToPaymentLink () {
      try {
        if (!this.bookingItem || this.bookingItem.length === 0) {
          console.warn('goToPaymentLink: bookingItem is empty or undefined')
          return
        }
        let dataPayment = {
          shopId: this.$route.query.shopId,
          bookNo: this.bookingItem[0].bookNo
        }
        await axios
          .post(this.DNS_IP + '/stripe/createProduct', dataPayment)
          .then(async responses => {
            if (responses.data.status !== false) {
              this.paymentLink = responses.data.paymentLink
              if (this.paymentLink !== '') {
                window.location.href = this.paymentLink
              }
            } else {
              this.paymentLink = ''
            }
          })
          .catch(function (error) {
            console.log('Error createProduct stripe:', error)
          })
      } catch (error) {
        console.error('goToPaymentLink critical error:', error)
      }
    },
    async checkMember (bookNo) {
      try {
        await axios
          .get(this.DNS_IP + '/booking_view/get?bookNo=' + bookNo)
          .then(async response => {
            let rs = response.data
            if (rs && rs.length > 0) {
              if (rs[0].lineUserId === null || rs[0].lineUserId === '') {
                this.checkMemberId = 'memberNo'
              } else {
                this.checkMemberId = 'memberTrue'
              }
            } else {
              this.checkMemberId = 'memberNo'
            }
          })
          .catch(function (error) {
            console.log('Error checkMember axios: ' + error)
            this.checkMemberId = 'memberNo'
          })
      } catch (error) {
        console.error('checkMember critical error:', error)
        this.checkMemberId = 'memberNo'
      }
    },
    async getBotinfo () {
      try {
        if (this.$route.query.shopId) {
          const url = `${this.DNS_IP}/line/getOa`
          // const url = 'http://localhost:81/Api/vgroupl_api/v1/Zoom/Login/getData?'
          const config = {
            headers: {
              botId: this.$route.query.shopId
            }
          }
          if (
            this.$route.query.redirectBy === 'BookingForm' ||
            this.$route.query.redirectBy === 'PaymentUpload'
          ) {
            await this.checkMember(this.$route.query.bookNo)
          } else {
            this.checkMemberId = 'memberTrue'
          }
          await axios
            .get(url, config)
            .then(response => {
              let rs = response.data
              if (rs && rs.basicId) {
                if (this.checkMemberId === 'memberNo') {
                  window.location.href =
                    'https://line.me/R/oaMessage/' +
                    rs.basicId +
                    `/?\u0e40\u0e1b\u0e34\u0e14\u0e23\u0e31\u0e1a\u0e01\u0e32\u0e23\u0e41\u0e08\u0e49\u0e07\u0e40\u0e15\u0e37\u0e2d\u0e19`
                } else {
                  window.location.href = 'line://ti/p/' + rs.basicId
                }
              }
            })
            .catch(error => {
              console.log('Error getBotinfo axios: ' + error)
            })
        }
      } catch (error) {
        console.error('getBotinfo critical error:', error)
      }
    },
    setText () {
      let check = this.redirectBy
      if (check === 'rating') {
        this.redirectBy = check
        this.textByredirectBy = `แบบประเมินความพึงพอใจของผู้ใช้บริการที่มีต่อ ${this.shop[0].shopName} \n
        เพื่อเป็นแนวทางในการพัฒนาและปรับปรุงการให้บริการให้มีประสิทธิภาพและสอดคล้องกับความต้องการของผู้ใช้บริการต่อไป
         \n หมายเหตุ
         \n - สรุปการให้คะแนนความพึงพอใจจะสามารถดูได้เฉพาะ   ผู้ดูแลระบบ ${this.shop[0].shopName} เท่านั้น`
      } else if (check === 'BookingForm') {
        this.redirectBy = check
      } else if (check === 'BookingAdmin') {
        this.redirectBy = check
      } else if (check === 'stampStepNoStep') {
        this.redirectBy = check
        this.textByredirectBy = `ไม่มีขั้นตอนที่ท่านเลือก \n กรุณาติดต่อเจ้าหน้าที่`
      } else if (check === 'stampStepDuplicateStep') {
        this.redirectBy = check
        this.textByredirectBy = `ท่านอยู่ขั้นตอนนี้อยู่แล้ว \n กรุณาติดต่อเจ้าหน้าที่`
      } else if (check === 'stampStepNoService') {
        this.redirectBy = check
        this.textByredirectBy = `ไม่มีนัดหมายเข้ารับบริการนี้ \n กรุณาติดต่อเจ้าหน้าที่`
      } else if (check === 'stampStep') {
        this.redirectBy = check
        this.textByredirectBy = `ทำรายการเสร็จเรียบร้อย`
      } else if (check === 'ratingDuplicate') {
        this.redirectBy = check
        this.textByredirectBy = `แบบประเมินความพึงพอใจของผู้ใช้บริการที่มีต่อ ${this.shop[0].shopName} \n
        เพื่อเป็นแนวทางในการพัฒนาและปรับปรุงการให้บริการให้มีประสิทธิภาพและสอดคล้องกับความต้องการของผู้ใช้บริการต่อไป
         \n หมายเหตุ
         \n - หากลูกค้าให้คะแนนความพึงพอใจไปแล้ว ระบบจะยึดการประเมินครั้งแรกเท่านั้น`
      } else if (check === 'ratingNoData') {
        this.redirectBy = check
        this.textByredirectBy = `ไม่พบข้อมูลของท่าน \n กรุณาทำรายการใหม่อีกครั้ง`
      } else if (check === 'ratingNoSave') {
        this.redirectBy = check
        this.textByredirectBy = `บันทึกไม่สำเร็จ \n กรุณาทำรายการใหม่อีกครั้ง`
      } else if (check === 'stampFirstStepErrorNoBook') {
        this.redirectBy = check
        this.textByredirectBy = `ไม่พบข้อมูลของท่าน \n\n หากท่านยังไม่ได้ทำการนัดหมาย \n กรุณาติดต่อเจ้าหน้าที่ Admin
         \n เพื่อทำการนัดมายจองคิว ได้ 2 ช่องทางนี้
         \n เคาน์เตอร์ประชาสัมพันธ์ \n
         Tel : ${this.shop[0].contactTel} \n
         (กรณีไม่ได้นัดหมาย ${this.shop[0].shopName} จะไม่สามารถใช้บริการได้)`
      } else if (check === 'stampFirstStepErrorNoDate') {
        this.redirectBy = check
        this.textByredirectBy = `ไม่พบข้อมูลของท่าน \n กรุณาตรวจสอบข้อมูลการนัดหมายของท่าน
         \n หรือท่านไม่อยู่ในรายชื่อที่สามารถเข้ารับบริการในวันนี้
         \n เคาน์เตอร์ประชาสัมพันธ์ `
      } else if (check === 'stampFirstStep') {
        this.redirectBy = check
        this.textByredirectBy = `ท่านสามารถเช็คลำดับคิวของท่านได้ที่ ปุ่มด้านล่าง`
      } else if (check === 'PaymentUpload') {
        this.redirectBy = check
        this.textByredirectBy = `ไม่มีนัดหมายเข้ารับบริการนี้ \n กรุณาติดต่อเจ้าหน้าที่`
      } else if (check === 'notAcceptedPDPA') {
        this.textByredirectBy = `ระบบไม่สามารถดำเนินการจองได้ \n หากคุณไม่ยอมรับข้อตกลง PDPA`
      } else if (check === 'OnsiteRating' || check === 'OnSiteRating') {
        this.redirectBy = 'N'
        // this.textByredirectBy = `แบบประเมินความพึงพอใจของผู้ใช้บริการที่มีต่อ ${this.shop[0].shopName} \n
        // เพื่อเป็นแนวทางในการพัฒนาและปรับปรุงการให้บริการให้มีประสิทธิภาพและสอดคล้องกับความต้องการของผู้ใช้บริการต่อไป
        //  \n หมายเหตุ
        //  \n - สรุปการให้คะแนนความพึงพอใจจะสามารถดูได้เฉพาะ   ผู้ดูแลระบบ ${this.shop[0].shopName} เท่านั้น`
      } else {
        this.redirectBy = 'N'
      }
      console.log('redirectBy', check)
    },
    async getShop () {
      if (this.$route.query.redirectBy) {
        let check = this.$route.query.redirectBy
        if (check === 'rating') {
          this.redirectBy = check
        } else if (check === 'BookingForm') {
          this.redirectBy = check
        } else if (check === 'BookingAdmin') {
          this.redirectBy = check
        } else if (check === 'stampStepNoStep') {
          this.redirectBy = check
        } else if (check === 'stampStepDuplicateStep') {
          this.redirectBy = check
        } else if (check === 'stampStepNoService') {
          this.redirectBy = check
        } else if (check === 'stampStep') {
          this.redirectBy = check
        } else if (check === 'ratingDuplicate') {
          this.redirectBy = check
        } else if (check === 'ratingNoData') {
          this.redirectBy = check
        } else if (check === 'ratingNoSave') {
          this.redirectBy = check
        } else if (check === 'stampFirstStepErrorNoBook') {
          this.redirectBy = check
        } else if (check === 'stampFirstStepErrorNoDate') {
          this.redirectBy = check
        } else if (check === 'stampFirstStep') {
          this.redirectBy = check
        } else if (check === 'PaymentUpload') {
          this.redirectBy = check
        } else if (check === 'omisePayment') {
          this.redirectBy = check
        } else if (check === 'notAcceptedPDPA') {
          this.redirectBy = check
        } else if (check === 'OnsiteRating' || check === 'OnSiteRating') {
          this.redirectBy = 'N'
        } else {
          this.redirectBy = 'N'
        }
      } else {
        this.redirectBy = null
      }
      if (this.$route.query.shopId) {
        await axios
          .get(this.DNS_IP + '/sys_shop/get?shopId=' + this.$route.query.shopId)
          .then(async response => {
            let rs = response.data
            if (rs.length > 0) {
              this.shop = rs
              rs.forEach(v => {
                if (v.primaryColor) {
                  this.ColorByShop.push(v.primaryColor, v.secondaryColor)
                  this.DarkModeBackground = v.primaryColor
                  this.DarkModeButton = v.secondaryColor
                } else {
                  this.ColorByShop.push('#E1F3FF', '#FFFFFF')
                  this.DarkModeBackground = '#FFFFFF'
                  this.DarkModeButton = '#E1F3FF'
                }
                if (v.shopImge) {
                  this.LoGo = v.shopImge
                } else {
                  this.LoGo = require('@/assets/Thank.svg')
                }
                if (v.shopImageCover) {
                  this.ImgCover = v.shopImageCover
                } else {
                  if (v.category === 'ธุรกิจรถยนต์') {
                    this.ImgCover = require('@/assets/Cover2.jpg')
                  } else {
                    this.ImgCover = require('@/assets/Cover2.jpg')
                  }
                }
                if (v.darkMode === 'True') {
                  this.DarkMode = '#FFFFFF'
                  this.DarkModefont = '#FFFFFF'
                } else {
                  this.DarkMode = ''
                  this.DarkModefont = '#173053'
                }
              })
              if (
                rs[0].showQrPayments === null ||
                rs[0].showQrPayments === ''
              ) {
                this.showQrPayments = 'False'
              } else {
                this.showQrPayments = rs[0].showQrPayments
              }
              this.bookingthankText = rs[0].bookingthankText || ''
              this.bookingthankTextEn = rs[0].bookingthankTextEn || ''
              this.statusGoogleCalendar = rs[0].statusGoogleCalendar
              this.statusGoogleCalendarEmp = rs[0].statusGoogleCalendarEmp
            } else {
              this.shop = null
            }
          })
          .catch(error => {
            console.log('error getShop: ', error)
          })
      } else {
        this.ColorByShop.push('#E1F3FF', '#FFFFFF')
        this.LoGo = require('@/assets/Thank.svg')
        this.DarkMode = ''
        this.DarkModefont = '#173053'
      }
    },
    async saveUserId () {
      await this.checkLiffLogin(this.dataLineConfig)
      if (this.profile && this.profile.userId) {
        let userId = {
          userId: this.profile.userId
        }
        await axios
          .post(this.DNS_IP + '/Booking/edit/' + this.bookNo, userId)
          .then(async response => {
            // if (this.dataLineConfig.checkConfig !== false) {
            this.getDataChkMember()
            // }
          })
          .catch(error => {
            console.log('error saveUserId: ', error)
          })
      }
    },
    async getBookings () {
      try {
        if (this.bookNo) {
          await axios
            .get(
              this.DNS_IP +
                  '/Booking/get?shopId=' +
                  this.shopId +
                  '&bookNo=' +
                  this.bookNo
            )
            .then(async response => {
              let rs = response.data
              if (rs && rs.length > 0) {
                this.bookingItem = rs
                if (this.bookingItem[0].paymentType === 'rabbit' && this.$route.query.redirectBy !== 'completedPayment') {
                  if (this.bookingItem[0].paymentLinkStatus === 'CONFIRMED') {
                    this.$swal({
                      title: 'success',
                      type: 'success',
                      text: 'ชำระเงินสำเร็จขอบคุณที่ใช้บริการ',
                      confirmButtonColor: '#3085d6',
                      cancelButtonColor: '#b3b1ab',
                      confirmButtonText: 'ตกลง'
                    }).then(async result => {
                      // alert('BookingForm')
                      this.$router.push(
                        '/Thank?shopId=' +
                            this.shopId +
                            '&redirectBy=completedPayment&flowId=' +
                            this.$route.query.flowId +
                            '&bookNo=' +
                            this.bookNo
                      )
                      window.location.reload()
                    }).catch(error => {
                      console.log('error function success : ', error)
                      this.$router.push(
                        '/Thank?shopId=' +
                            this.shopId +
                            '&redirectBy=completedPayment&flowId=' +
                            this.$route.query.flowId +
                            '&bookNo=' +
                            this.bookNo
                      )
                      window.location.reload()
                    })
                  }
                }
                if (this.$route.query.redirectBy === 'rabbitPayment') {
                  if (this.bookingItem[0].paymentLinkStatus === 'CONFIRMED') {
                    this.$swal({
                      title: 'success',
                      type: 'success',
                      text: 'ชำระเงินสำเร็จขอบคุณที่ใช้บริการ',
                      confirmButtonColor: '#3085d6',
                      cancelButtonColor: '#b3b1ab',
                      confirmButtonText: 'ตกลง'
                    }).then(async result => {
                      // alert('BookingForm')
                      this.$router.push(
                        '/Thank?shopId=' +
                            this.shopId +
                            '&redirectBy=completedPayment&flowId=' +
                            this.$route.query.flowId +
                            '&bookNo=' +
                            this.bookNo
                      )
                      window.location.reload()
                    }).catch(error => {
                      console.log('error function success : ', error)
                      this.$router.push(
                        '/Thank?shopId=' +
                            this.shopId +
                            '&redirectBy=completedPayment&flowId=' +
                            this.$route.query.flowId +
                            '&bookNo=' +
                            this.bookNo
                      )
                      window.location.reload()
                    })
                  } else {
                    this.$swal({
                      title: 'ผิดพลาด',
                      type: 'error',
                      text:
                          'มีบางอย่างผิดพลาดในการชำระเงิน ต้องการย้อนกลับไปชำระเงินหรือไม่ ?',
                      showCancelButton: true,
                      confirmButtonColor: '#3085d6',
                      cancelButtonColor: '#b3b1ab',
                      confirmButtonText: 'ตกลง'
                    }).then(async result => {
                      // alert('BookingForm')
                      this.$router.push(
                        '/Thank?shopId=' +
                            this.shopId +
                            '&redirectBy=BookingForm&flowId=' +
                            this.$route.query.flowId +
                            '&bookNo=' +
                          this.bookNo
                      )
                      window.location.reload().catch(error => {
                        console.log('error function addData : ', error)
                      })
                    })
                  }
                }
                if (this.$route.query.redirectBy === 'omisePayment') {
                  if (this.bookingItem[0].paymentLinkStatus === 'successful') {
                    this.$swal({
                      title: 'success',
                      type: 'success',
                      text: 'ชำระเงินสำเร็จขอบคุณที่ใช้บริการ',
                      confirmButtonColor: '#3085d6',
                      cancelButtonColor: '#b3b1ab',
                      confirmButtonText: 'ตกลง'
                    })
                  } else if (
                    this.bookingItem[0].paymentLinkStatus === 'pending'
                  ) {
                    this.$swal({
                      title: 'รอนำเนินการ',
                      type: 'warning',
                      text: 'กำลังตรวจการชำระเงิน',
                      confirmButtonColor: '#3085d6',
                      cancelButtonColor: '#b3b1ab',
                      confirmButtonText: 'ตกลง'
                    })
                  } else {
                    this.$swal({
                      title: 'ผิดพลาด',
                      type: 'error',
                      text:
                        'มีบางอย่างผิดพลาดในการชำระเงิน ต้องการย้อนกลับไปชำระเงินหรือไม่ ?',
                      showCancelButton: true,
                      confirmButtonColor: '#3085d6',
                      cancelButtonColor: '#b3b1ab',
                      confirmButtonText: 'ตกลง'
                    }).then(async result => {
                    // alert('BookingForm')
                      this.$router.push(
                        '/Thank?shopId=' +
                          this.shopId +
                          '&redirectBy=BookingForm&flowId=' +
                          this.$route.query.flowId +
                          '&bookNo=' +
                          this.bookNo
                      )
                      window.location.reload().catch(error => {
                        console.log('error function addData : ', error)
                      })
                    })
                  }
                }
              }
              this.overlay = false
            }).catch(err => {
              this.overlay = false
              // this.$router.push({ name: '404' })
              console.log(err.code, err.message)
            })
        } else {
          this.overlay = false
        }
      } catch (error) {
        console.error('getBookings critical error:', error)
        this.overlay = false
      }
    },
    async getBooking () {
      try {
        if (this.redirectBy === 'BookingAdmin') {
          await axios
            .get(
              this.DNS_IP +
                '/Booking/get?shopId=' +
                this.shopId +
                '&bookNo=' +
                this.bookNo
            )
            .then(response => {
              let rs = response.data
              if (rs && rs.length > 0) {
                this.bookingItem = rs
                if (
                  rs[0].depositPrice === null ||
                  rs[0].depositPrice === '' ||
                  rs[0].depositPrice === '0'
                ) {
                  this.redirectBy = 'N'
                  if (
                    rs[0].userId === 'user-skip' ||
                    rs[0].userId === null ||
                    rs[0].userId === ''
                  ) {
                    this.saveUserId()
                    this.pushMsgLineNotifyGroup(this.bookNo)
                  }
                } else {
                  this.depositPrice = parseFloat(rs[0].depositPrice)
                  if (
                    rs[0].userId === 'user-skip' ||
                    rs[0].userId === null ||
                    rs[0].userId === ''
                  ) {
                    this.saveUserId()
                  }
                }
              }
            })
            .catch(error => {
              console.log('Error getBooking axios: ' + error)
            })
        } else if (this.bookNo) {
          this.overlay = true
          await new Promise(resolve => setTimeout(resolve, 5000))
          await this.getBookings()
        } else {
          this.overlay = false
        }
      } catch (error) {
        console.error('getBooking critical error:', error)
        this.overlay = false
      }
    },
    async checkLiffLogin (dataLineConfig) {
      console.log('dataLineConfig', dataLineConfig)
      await this.$liff
        .init({
          liffId: dataLineConfig.liffMainID
        })
        .then(async () => {
          if (process.env.NODE_ENV === 'development') {
            this.getProfile_dev()
          } else {
            if (!this.$liff.isLoggedIn()) {
              this.$liff.login({ redirectUri: window.location.href })
            } else {
              await this.getProfile()
            }
          }
        })
        .catch(err => {
          // this.$router.push({ name: '404' })
          console.log(err.code, err.message)
        })
      // this.$liff.init({ 'liffId': liffId }, function (data) {})
    },
    async getProfile () {
      let _this = this
      await this.$liff
        .getProfile()
        .then(function (profile) {
          _this.profile = profile
          console.log('prod', _this.profile)
        })
        .catch(function (error) {
          console.log('Error getting profile: ' + error)
        })
    },
    getProfile_dev () {
      this.profile = this.$profile_dev
    },
    async creditCardFnc () {
      try {
        let rs = this.DataFlow
        if (rs && rs.length > 0) {
          if (this.redirectBy === 'BookingAdmin') {
            if (rs[0].checkCreditCard === 'True' || rs[0].checkCoupon === 'True') {
              if (this.bookingItem && this.bookingItem.length > 0) {
                if (
                  this.bookingItem[0].depositPrice === null ||
                  this.bookingItem[0].depositPrice === '' ||
                  this.bookingItem[0].depositPrice === '0'
                ) {
                  this.statuscheckCreditCard = 'False'
                  this.statuscheckCoupon = 'False'
                  this.dialogCreditCard = false
                } else {
                  this.statuscheckCreditCard = rs[0].checkCreditCard || 'False'
                  this.statuscheckCoupon = rs[0].checkCoupon || 'False'
                  this.dialogCreditCard = true
                }
              } else {
                this.statuscheckCreditCard = 'False'
                this.statuscheckCoupon = 'False'
                this.dialogCreditCard = false
              }
            } else {
              this.statuscheckCreditCard = 'False'
              this.statuscheckCoupon = 'False'
              this.dialogCreditCard = false
            }
          }
          if (this.redirectBy === 'BookingForm') {
            const isCouponUsed = await this.checkIsCashCouponLoyalty()
            if (isCouponUsed) {
              this.statuscheckCreditCard = 'False'
              this.statuscheckCoupon = 'False'
              this.dialogCreditCard = false
              return 'coupon_used'
            }
            if (rs[0].checkCreditCard === 'True' || rs[0].checkCoupon === 'True') {
              this.statuscheckCreditCard = rs[0].checkCreditCard || 'False'
              this.statuscheckCoupon = rs[0].checkCoupon || 'False'
              if (this.bookingItem && this.bookingItem.length > 0) {
                let checkDepositPrice = parseFloat(
                  this.bookingItem[0].depositPrice || 0
                )
                if (
                  (checkDepositPrice > 0 || this.depositPrice > 0) &&
                  rs[0].checkCreditCard === 'True'
                ) {
                  this.dialogCreditCard = true
                }
                if (rs[0].checkCoupon === 'True') {
                  this.dialogCreditCard = true
                }
              }
            } else if (this.shopId === this.shopNameData.cJAutoGallery) {
              const statusGetPackage = await this.getPackageLoyalty()
              if (statusGetPackage) {
                this.statuscheckPagkageLoyalty = 'True'
                this.dialogCreditCard = true
              }
            } else {
              this.statuscheckCreditCard = 'False'
              this.statuscheckCoupon = 'False'
              this.dialogCreditCard = false
            }
          }
        }
        return 'normal'
      } catch (error) {
        console.error('creditCardFnc error:', error)
        this.statuscheckCreditCard = 'False'
        this.statuscheckCoupon = 'False'
        this.dialogCreditCard = false
        return 'normal'
      }
    },

    async checkIsCashCouponLoyalty () {
      try {
        if (!this.bookingItem || this.bookingItem.length === 0) {
          return false
        }
        const bkData = this.bookingItem[0]
        if (bkData.depositStatus === 'True') {
          return false
        }

        if (!bkData.tokenPackage) {
          return false
        }

        const response = await axios.get(
          this.IPPotocalENV_ProductionLoyalty +
            '/PackageLog/get?shopId=' +
            bkData.shopId +
            '&userId=' +
            bkData.lineUserId +
            '&flowId=' +
            bkData.flowId
        )
        if (response.data && response.data.length > 0) {
          const dataPage = response.data.find((item) => item.token === bkData.tokenPackage)
          if (dataPage && dataPage.isCashCoupon === 'True') {
            const statusUsePackage = await this.usePackage(bkData.tokenPackage)
            if (statusUsePackage) {
              await this.updateBookingTransaction()
              return true
            }
          }
        }

        return false
      } catch (error) {
        console.error('Error in checkIsCashCouponLoyalty:', error)
        return false
      }
    },
    async usePackage (token) {
      try {
        let amountOf = 1
        let params = {
          amountOf: amountOf
        }
        const response = await axios.post(this.DNS_IP_Loyalty + '/use_package/edit?shopId=' + this.shopId + '&token=' + token, params, {
          headers: {
            shopId: this.shopId
          }
        })
        console.log('usePackage success:', response.data)
        return true
      } catch (error) {
        console.error('Error in usePackage:', error)
        return false
      }
    },
    async updateBookingTransaction () {
      try {
        if (!this.bookingItem || this.bookingItem.length === 0) {
          console.warn('updateBookingTransaction: bookingItem is empty or undefined')
          return
        }
        let flowId = this.bookingItem[0].flowId
        let bodyObj = {
          bookNo: this.bookingItem[0].bookNo,
          depositStatus: 'True',
          paymentType: 'creditloyalty'
        }

        // 1. อัปเดตสถานะบิลหลัก
        await axios.post(
          this.DNS_IP + '/Booking/edit/' + bodyObj.bookNo,
          bodyObj
        )

        // ส่งข้อความแจ้ง Line กลุ่ม
        this.pushMsgLineNotifyGroup(bodyObj.bookNo)

        // 2. จัดเตรียมข้อมูลรายการ (Transaction) ยืนยันคูปอง
        let dtt = {
          bookNo: bodyObj.bookNo,
          contactDate: moment().format('YYYY-MM-DD HH:mm'),
          status: 'confirm',
          statusUse: 'use',
          shopId: this.shopId,
          CREATE_USER: this.bookingItem[0].lineUserId,
          LAST_USER: this.bookingItem[0].lineUserId
        }

        // 3. บันทึก Transaction
        await axios.post(this.DNS_IP + '/booking_transaction/add', dtt)

        // 4. (เผื่อมีเงื่อนไขเปิดใช้งาน Google Calendar ไว้) นำข้อมูลปฏิทินเพิ่มเข้าไป
        if (this.statusGoogleCalendar === 'True') {
          this.connectGoogleCalendar(
            dtt.shopId,
            'Add',
            dtt.bookNo
          )
        }

        // 5. ส่งข้อความ Confirm ไปหาผู้จอง
        this.pushMsgConfirm(bodyObj.bookNo, flowId)
      } catch (error) {
        console.error('error function updateBookingTransaction:', error)
      }
    },
    async getPackageLoyalty () {
      try {
        if (this.bookingItem && this.bookingItem.length && this.bookingItem[0].lineUserId) {
          const lineUserId = this.bookingItem[0].lineUserId
          // const lineUserId = 'U584759782e2257d2b5c9d6f90267f8a1'
          let shopIdFix = this.shopNameData.cJAutoGallery
          const result = await axios.get(this.IPPotocalENV_ProductionLoyalty + '/getCredits?shopId=' + shopIdFix + '&current_credits=0&lineUserId=' + lineUserId)
          if (result.data && result.data.length > 0) {
            this.usePackageLoyalty.memberId = result.data[0].memberId
            this.usePackageLoyalty.current_credits = result.data[0].current_credits
            this.usePackageLoyalty.total_credits = result.data[0].total_credits
            this.usePackageLoyalty.statusUse = true
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      } catch (error) {
        console.log('error')
        return false
      }
    },
    async getDataFlow () {
      this.DataFlow = []
      if (this.flowId) {
        await axios
          .get(
            this.DNS_IP +
              '/flow/get?shopId=' +
              this.shopId +
              '&flowId=' +
              this.flowId
          )
          .then(response => {
            let rs = response.data
            if (rs.length > 0) {
              this.depositTime = rs[0].depositTime
              for (var i = 0; i < rs.length; i++) {
                let d = rs[i]
                this.DataFlow.push(d)
              }
            } else {
              this.DataFlow = []
            }
          }).catch(async (error) => {
            console.log('getDataFlow error: ', error)
          })
      }
    },
    async pushMsgLineNotifyGroup (bookNo) {
      await axios
        .post(this.DNS_IP + '/Booking/pushMsgLineNotifyGroupBefamily/' + bookNo)
        .then(response => {})
    },
    gotocheckCreditCardOnline () {
      if (this.checkboxPromtpayOnline === true) {
        this.goToPaymentLink()
      } else {
        this.goToPaymentLinkOmise()
      }
    },
    async gotocheckCreditCard () {
      if (this.checkboxCreditCard === 'True') {
        let paymentLinkStatusCheck = this.bookingItem[0].paymentLinkStatus || ''
        let paymentLinkCheck = this.bookingItem[0].paymentLink || ''
        let checkOmise = this.dataPaymentGet.filter(el => {
          return el.payType === 'omise'
        })
        let checkStripe = this.dataPaymentGet.filter(el => {
          return el.payType === 'stripe'
        })
        if (checkOmise.length > 0 && checkStripe.length > 0) {
          this.dialogSelectOnlinePayment = true
          this.dialogCreditCard = false
        } else if (checkOmise.length === 0 && checkStripe.length > 0) {
          if (paymentLinkStatusCheck === 'create') {
            // this.redirectBy = 'createPayment'
            this.stripeBtstatus = true
            window.location.href = paymentLinkCheck
            // this.paymentLink = paymentLinkCheck
            // this.value = generatePayload(promptPayID, { amount })
          } else if (paymentLinkStatusCheck === 'completed') {
            this.redirectBy = 'completedPayment'
            this.dialogSelectOnlinePayment = false
            this.dialogCreditCard = false
          } else {
            this.goToPaymentLink()
          }
        } else if (checkOmise.length > 0 && checkStripe.length === 0) {
          if (
            paymentLinkStatusCheck === 'pending' ||
            paymentLinkStatusCheck === '' ||
            paymentLinkStatusCheck === 'False'
          ) {
            this.goToPaymentLinkOmise()
          } else {
            this.redirectBy = 'completedPayment'
          }
        }
      } else if (this.checkboxPackageLoyalty === 'True') {
        this.$swal({
          title: this.languageSelect === 0 ? 'ยืนยันการทำรายการ' : 'Confirm',
          type: 'info',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#b3b1ab',
          confirmButtonText: this.languageSelect === 0 ? 'ยอมรับ' : 'Accept',
          cancelButtonText: this.languageSelect === 0 ? 'ไม่ยอมรับ' : 'Not accepted'
        })
          .then(async result => {
            this.overlay = true
            const resUsePackage = await this.decreasePackage()
            console.log('resUsePackageresUsePackage', resUsePackage)
            if (resUsePackage) {
              await this.saveBookingStatus()
            } else {
              this.overlay = false
              await this.$swal({
                title: this.languageSelect === 0 ? 'ไม่สำเร็จ' : 'Failed',
                text: this.languageSelect === 0
                  ? 'หักเครดิต ไม่สำเร็จ'
                  : 'Credit deduction Failed.',
                type: 'error',
                showConfirmButton: true
              })
            }
          })
          .catch(async (error) => {
            this.overlay = false
            await this.$swal({
              title: this.languageSelect === 0 ? 'ไม่สำเร็จ' : 'Failed',
              text: this.languageSelect === 0
                ? 'หักเครดิต ไม่สำเร็จ'
                : 'Credit deduction Failed.',
              type: 'error',
              showConfirmButton: true
            })
            console.log('Error getting profile: ' + error)
          })
      } else if (this.checkboxRabbit === 'True') {
        if (this.depositPrice === 0 || this.depositPrice === '') {
          this.$swal(
            'ผิดพลาด!',
            'กรุณากรอกจำนวนเงินที่ต้องการชำระ',
            'error'
          )
          return
        }
        const thankHref = this.$router.resolve({
          path: '/Thank',
          query: {
            shopId: this.shopId,
            redirectBy: 'rabbitPayment',
            flowId: this.$route.query.flowId,
            bookNo: this.bookNo
          }
        }).href
        const bodyRabbit = {
          'Authorization': this.dataRabbit.api_rabbit,
          'amount': this.depositPrice * 100,
          'currency': 'THB',
          'provider': 'prompt_pay',
          'bookNo': this.bookNo,
          'redirectUrl': new URL(thankHref, window.location.origin).toString()
        }
        axios.post(this.DNS_IP + '/rabbit_gateway', bodyRabbit)
          .then(resRabbit => {
            if (resRabbit.data.shortUrl !== '') {
              window.location.href = resRabbit.data.shortUrl
            }
          }).catch((error) => {
            console.log('error', error)
            this.$swal(
              'ผิดหลาด!',
              'กรุณาทำรายการใหม่',
              'error'
            )
          })
      } else {
        if (this.checkboxCoupon === 'True') {
          this.$router.push(
            '/PaymentUpload?bookNo=' +
              this.bookNo +
              '&shopId=' +
              this.shopId +
              '&languageSelect=' +
              this.languageSelect +
              '&flowId=' +
              this.$route.query.flowId +
              '&depositPrice=' +
              this.depositPrice +
              '&coupon=true'
          )
        } else {
          this.dialogCreditCard = false
        }
      }
    },
    gotoPaymentUpload () {
      this.$router.push(
        '/PaymentUpload?bookNo=' +
          this.bookNo +
          '&shopId=' +
          this.shopId +
          '&languageSelect=' +
          this.languageSelect +
          '&flowId=' +
          this.$route.query.flowId +
          '&depositPrice=' +
          this.depositPrice
      )
    },
    async decreasePackage () {
      try {
        if (!this.bookingItem || this.bookingItem.length === 0) {
          console.warn('decreasePackage: bookingItem is empty')
          return false
        }
        let statusUse = false
        let bodyObj = {
          'memberId': this.usePackageLoyalty.memberId,
          'Amount_credited': this.depositPrice,
          'time': moment().locale('th').format('HH:mm'),
          'date': moment().locale('th').format('DD MMM YYYY'),
          'flowId': this.bookingItem[0].flowId
        }
        await axios.post('https://api-beloyalty-productions.betaskthai.tech/decrease-booking/belink', bodyObj)
          .then((response) => {
            if (response.data.status) {
              statusUse = true
            } else {
              statusUse = false
            }
          }).catch((error) => {
            console.log('error', error)
            statusUse = false
          })
        return statusUse
      } catch (error) {
        return false
      }
    },
    async saveBookingStatus () {
      try {
        if (!this.bookingItem || this.bookingItem.length === 0) {
          console.warn('saveBookingStatus: bookingItem is empty')
          return
        }
        let flowId = this.bookingItem[0].flowId
        let bodyObj = {
          bookNo: this.bookingItem[0].bookNo,
          depositStatus: 'True',
          paymentType: 'creditloyalty'
        }
        await axios
          .post(
            this.DNS_IP + '/Booking/edit/' + bodyObj.bookNo,
            bodyObj
          )
          .then(async response => {
            this.pushMsgLineNotifyGroup(bodyObj.bookNo)
            let dtt = {
              bookNo: bodyObj.bookNo,
              contactDate: moment().format('YYYY-MM-DD HH:mm'),
              status: 'confirm',
              statusUse: 'use',
              shopId: this.shopId,
              CREATE_USER: this.bookingItem[0].lineUserId,
              LAST_USER: this.bookingItem[0].lineUserId
            }
            await axios
              .post(this.DNS_IP + '/booking_transaction/add', dtt)
              .then(async response => {
                if (this.statusGoogleCalendar === 'True') {
                  this.connectGoogleCalendar(
                    dtt.shopId,
                    'Add',
                    dtt.bookNo
                  )
                }
              })
              .catch(error => {
                console.log(
                  'error function booking_transaction : ',
                  error
                )
              })
            await this.$swal({
              title: this.languageSelect === 0 ? 'สำเร็จ' : 'Success',
              text: this.languageSelect === 0
                ? 'หักเครดิต สำเร็จ'
                : 'Credit deduction successful.',
              type: 'success',
              showConfirmButton: true
            })
              .then(async result => {
                this.pushMsgConfirm(bodyObj.bookNo, flowId)
              })
              .catch(function (error) {
                this.pushMsgConfirm(bodyObj.bookNo, flowId)
                console.log('Error getting profile: ' + error)
              })
          })
      } catch (error) {
        console.log('error', error)
        this.overlay = false
      } finally {
        this.overlay = false
      }
    },
    async connectGoogleCalendar (shopId, status, bookNo) {
      const payload = {
        bookNo: bookNo,
        status: status
      }
      await axios
        .post(this.DNS_IP + '/GoogleCalendarApi/event/byBookNo', payload)
        .then(response => {
          console.log('response connectGoogleCalendar : ', response)
        })
        .catch((error) => {
          console.log('error connectGoogleCalendar : ', error)
        })
      // if (this.$refs.GoogleCalendarRef) {
      //   this.$refs.GoogleCalendarRef.checkTypeEvenEmp(shopId, status, bookNo)
      // }
    },
    async pushMsgConfirm (bookNo, flowId) {
      await axios
        .post(this.DNS_IP + '/Booking/pushMsgConfirm/' + bookNo)
        .then(async response => {
          await this.getCondition(flowId, 'Thank', bookNo)
        })
        .catch(error => {
          console.log('error function pushMsgQueue : ', error)
        })
    },
    async getCondition (flowId, text, bookNo) {
      try {
        const response = await axios.get(this.DNS_IP + '/flow/get?flowId=' + flowId + '&shopId=' + this.shopId)
        if (response && response.data) {
          let rs = response.data
          if (rs.status === false) {
            if (text === 'BookingQrcode') {
              this.$router.push(
                '/BookingQrcode?bookNo=' + bookNo + '&shopId=' + this.shopId
              )
            } else {
              this.$router.push(
                '/Thank?shopId=' +
                  this.shopId +
                  '&redirectBy=PaymentUpload&flowId=' +
                  flowId +
                  '&bookNo=' +
                  bookNo +
                  '&languageSelect=' +
                  this.languageSelect
              )
            }
          } else {
            if (rs && rs.length > 0 && rs[0].showCondition === 'แสดง') {
              this.$router.push(
                '/ConditionFlow?shopId=' + this.shopId + '&flowId=' + flowId
              )
            } else {
              if (text === 'BookingQrcode') {
                this.$router.push(
                  '/BookingQrcode?bookNo=' + bookNo + '&shopId=' + this.shopId
                )
              } else {
                this.$router.push(
                  '/Thank?shopId=' +
                    this.shopId +
                    '&redirectBy=PaymentUpload&flowId=' +
                    flowId +
                    '&bookNo=' +
                    bookNo +
                    '&languageSelect=' +
                    this.languageSelect
                )
                this.$router.go()
              }
            }
          }
        }
      } catch (error) {
        console.log('getCondition error:', error)
      }
    },
    // async getDataChkMember () {
    //   if (this.profile.userId) {
    //     await axios.get(this.DNS_IP + '/member/get?shopId=' + this.$route.query.shopId + '&liffUserId=' + this.profile.userId).then(async result => {
    //       var lineUserIds = ''
    //       var liffUserIds = ''
    //       if (result.data.status === false) {
    //         await this.onSubmit()
    //       } else {
    //         lineUserIds = result.data[0].lineUserId || ''
    //         liffUserIds = result.data[0].liffUserId || ''
    //         if (lineUserIds === '' && liffUserIds !== '') {
    //           await this.onUpdate(result.data[0].memberId)
    //         }
    //       }
    //     })
    //   }
    //   // } else {
    //   //   this.$swal(
    //   //     'ผิดหลาด!',
    //   //     'กรุณาทำรายการใหม่',
    //   //     'error'
    //   //   )
    //   // }
    // },
    async getDataChkMember () {
      if (this.profile && this.profile.userId) {
        axios
          .get(
            this.DNS_IP +
              '/member/get?shopId=' +
              this.$route.query.shopId +
              '&liffUserId=' +
              this.profile.userId
          )
          .then(async result => {
            if (result.data.status === false) {
              this.onSubmit()
            } else {
              this.onUpdate(result.data[0].memberId)
            }
          })
          .catch(error => {
            console.log('error getDataChkMember: ', error)
          })
      }
      // } else {
      //   this.$swal(
      //     'ผิดหลาด!',
      //     'กรุณาทำรายการใหม่',
      //     'error'
      //   )
      // }
    },
    async onSubmit () {
      if (!this.profile) return
      // var idMember = 'Link_' + Date.now()
      var idMember = moment().valueOf()
      const params = {
        name: this.profile.displayName,
        picture: this.profile.pictureUrl,
        liffUserId: this.profile.userId,
        lineUserId: this.profile.userId,
        shopId: this.$route.query.shopId,
        memberId: idMember,
        CREATE_USER: this.profile.userId,
        LAST_USER: this.profile.userId
      }
      const result = await this.callBeTaskAPIActivity(
        'post',
        `/member/add`,
        params
      )
      console.log(result)
    },
    async onUpdate (idMember) {
      if (!this.profile) return
      // "https://api-belinked.betaskthai.com/member/editWebhook/" + request.body.events[0].message.text.split(" ")[2]
      // window.location.replace(`https://access.line.me/dialog/bot/accountLink?linkToken=${this.$route.query.likeToken}&nonce=${idMember}-${this.profile.userId}`)
      // window.location.href = `https://access.line.me/dialog/bot/accountLink?linkToken=${this.$route.query.likeToken}&nonce=${idMember}-${this.profile.userId}`
      const params = {
        name: this.profile.displayName,
        picture: this.profile.pictureUrl,
        shopId: this.$route.query.shopId,
        LAST_USER: this.profile.userId
      }
      const result = await this.callBeTaskAPIActivity(
        'post',
        '/member/editWebhook/' + idMember,
        params
      )
      console.log(result)
    },
    async callBeTaskAPIActivity (method, url, params) {
      let result = null
      //   const token = this.$liff.getAccessToken() || '1234567890'
      await axios({
        method: method,
        // headers: {
        //   accessToken: token,
        //   lineUserId: this.profile.userId,
        //   activityId: this.formUpdate.activityId
        // },
        url: this.DNS_IP + url,
        data: params
      })
        .then(response => {
          result = response.data
        })
        .catch(error => {
          console.log(error)
          result = null
        })
      return result
    },
    async handleOmisepayment (token) {
      try {
        let omisePayment = (this.dataPaymentGet || []).filter(
          ii => ii.payType === 'omise'
        )
        let payVatExcludeOmise = 0
        if (omisePayment && omisePayment.length > 0) {
          payVatExcludeOmise = omisePayment[0].payVatExclude
        }

        if (token.startsWith('tokn_')) {
          if (!this.DataFlow || this.DataFlow.length === 0) {
            console.warn('handleOmisepayment: DataFlow is empty')
            return
          }
          let dt = {
            secretKey: this.endpointSecret,
            token: token,
            productName: this.DataFlow[0].flowName,
            amount: this.depositPrice,
            payVatExclude:
              payVatExcludeOmise > 0
                ? (payVatExcludeOmise / 100) * this.depositPrice
                : null,
            amountTotal:
              payVatExcludeOmise > 0
                ? (payVatExcludeOmise / 100) * this.depositPrice +
                  this.depositPrice
                : this.depositPrice,
            bookNo: this.bookNo,
            shopId: this.DataFlow[0].shopId,
            flowId: this.flowId
          }
          await axios
            .post(this.DNS_IP + '/omise/create_charge_credit', dt)
            .then(res => {
              this.statuscheckCreditCard = 'False'
              window.location.href = res.data.authorizeUri
            })
            .catch(err => {
              console.log(err)
            })
        } else {
          let dt = {
            secretKey: this.endpointSecret,
            apiKey: this.apiKey,
            token: token,
            productName: this.DataFlow[0].flowName,
            amount: this.depositPrice,
            payVatExclude:
              payVatExcludeOmise > 0
                ? (payVatExcludeOmise / 100) * this.depositPrice
                : null,
            amountTotal:
              payVatExcludeOmise > 0
                ? (payVatExcludeOmise / 100) * this.depositPrice +
                  this.depositPrice
                : this.depositPrice,
            bookNo: this.bookNo,
            shopId: this.DataFlow[0].shopId,
            flowId: this.flowId
          }
          await axios
            .post(this.DNS_IP + '/omise/create_charge_not_credit_card', dt)
            .then(res => {
              window.location.href = res.data.authorizeUri
            })
            .catch(err => {
              console.log(err)
            })
        }
      } catch (error) {
        console.error('handleOmisepayment error:', error)
      }
    }
  }
}
</script>

<style scoped>
.button {
  width: 45%;
  color: #fff;
  font-weight: 150;
  letter-spacing: 1px;
  margin: 6px 3px;
  padding: 10px 28px;
  border-radius: 25px !important;
  background-color: #0047a5;
}
.main {
  background-color: #ffffff;
  height: 100vh;
}
.content {
  overflow: auto;
  white-space: normal;
}
.a {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;
  max-height: 350px;
}
.CDcontend {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 7%;
  padding-right: 7%;
  width: 100%;
  border-radius: 20px 20px 20px 20px;
  height: 95px;
}
.CDcontendLoyalty {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 7%;
  padding-right: 7%;
  width: 100%;
  border-radius: 20px 20px 20px 20px;
  height: 130px;
}
</style>



// WEBPACK FOOTER //
// src/components/Booking/Thank.vue